// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:38:34.204Z
// Property: Broadway Chapter (ID: 5754272234864640)
// Collections: 22 amenities, 24 floorplans (live), 27 photos, 80 POIs, 5 reviews, 2 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5754272234864640",
  "property_external_id": "4978599",
  "property_zillow_url": "https://www.zillow.com/homedetails/401-Hemphill-St-Fort-Worth-TX-76104/308877638_zpid/",
  "property_apartments_url": "https://www.apartments.com/broadway-chapter-fort-worth-tx/2p8c7q8",
  "property_google_business_url": "https://www.google.com/maps/place/Broadway+Chapter/@32.7403009,-97.3314344,15z/data=!4m2!3m1!1s0x0:0xb93277aca872f66c?sa=X&ved=2ahUKEwiQu4aIiID3AhURFzQIHbd-BWwQ_BJ6BAhdEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443974196",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "broadway-chapter",
  "property_name": "Broadway Chapter",
  "property_website_url": "https://www.broadwaychapterapts.com/",
  "property_domain": "https://www.broadwaychapterapts.com/",
  "property_address": "401 Hemphill St",
  "property_full_address": "401 Hemphill St, Fort Worth, TX 76104",
  "property_address_1": "401 Hemphill St",
  "property_address_2": null,
  "property_address_city": "Fort Worth",
  "property_address_state": "TX",
  "property_address_zip_full": "76104-2274",
  "property_address_zip": "76104",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Bricktown",
  "property_address_latitude": "32.7401924",
  "property_address_longitude": "-97.3312342",
  "property_email": "broadway@alapts.com",
  "property_phone": "(817) 415-1000",
  "property_call_tracking_phone": "817-318-7044",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Start your next Fort Worth chapter at Broadway Chapter.</strong> Modern studio, one-, two-bedroom, and loft-style apartments pair design-forward interiors with standout spaces like a resident lounge, Zoom rooms, fitness center, and infinity-edge pool—all from a connected Near Southside address.</p>",
  "property_long_description": "<p><strong>Start your next Fort Worth chapter in the Near Southside.</strong> Broadway Chapter brings modern apartment living to the edge of Bricktown, with studio, one-bedroom, two-bedroom, and loft-style layouts surrounded by the energy of Magnolia Avenue, South Main Village, the Medical District, and downtown Fort Worth. From Hemphill Street, you’re close to local dining, breweries, galleries, live music, Trinity Metro routes, and quick connections to Sundance Square, the Cultural District, and I-30.</p><p>At home, your day can move from coffee in the resident lounge to focused time in the Zoom rooms or library, a workout in the <a href=\"/amenities\">Peloton-equipped fitness center</a>, and a swim beside the infinity-edge pool with in-pool loungers, grilling areas, and a fireside lounge. Inside, choose from <a href=\"/floor-plans\">open, design-forward floor plans</a> with wood-style plank flooring, stainless steel appliances, walk-in closets, full-size washer and dryer, keyless fob entry, oversized windows, and select balconies or dramatic loft ceilings with downtown views.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019d02f4-3eba-731d-bbbd-a7d533f8c7e6.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment kitchen with stainless steel appliances, island, and pendant lights.",
    "public_id": "019d02f4-3eba-731d-bbbd-a7d533f8c7e6",
    "storage_key": "property/5754272234864640/019d02f4-3eba-731d-bbbd-a7d533f8c7e6.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "242",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.56198347107438",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Admin Fee $150\nApp Fee $75\nApproval Fee $150\nApproved with Conditions $300\nPet Fee $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet & an additional $150 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet & an additional $150 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8877396.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://broadwaychapter.loftliving.com/login",
  "property_apply_now_url": "https://8877396.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e4371-7490-7517-97e1-a188e85fd6d1.webp",
  "property_primary_logo_media": {
    "alt_text": "Broadway Chapter logo",
    "public_id": "019e4371-7490-7517-97e1-a188e85fd6d1",
    "storage_key": "property/5754272234864640/019e4371-7490-7517-97e1-a188e85fd6d1.webp",
    "width": 1296,
    "height": 1094
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e4371-7085-73f9-938c-e019d4fb080f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Broadway Chapter logo on a red background",
    "public_id": "019e4371-7085-73f9-938c-e019d4fb080f",
    "storage_key": "property/5754272234864640/019e4371-7085-73f9-938c-e019d4fb080f.webp",
    "width": 1296,
    "height": 1094
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e4371-7041-77e3-aaf3-462b45df46fe.webp",
  "property_icon_media": {
    "alt_text": "Abstract graphic with red lines on a black background",
    "public_id": "019e4371-7041-77e3-aaf3-462b45df46fe",
    "storage_key": "property/5754272234864640/019e4371-7041-77e3-aaf3-462b45df46fe.webp",
    "width": 1028,
    "height": 1029
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e4371-7079-76c2-afe1-8ce33ecef865.webp",
  "property_fav_icon_media": {
    "alt_text": "Red abstract graphic with vertical lines and a wavy line inside a circle.",
    "public_id": "019e4371-7079-76c2-afe1-8ce33ecef865",
    "storage_key": "property/5754272234864640/019e4371-7079-76c2-afe1-8ce33ecef865.webp",
    "width": 532,
    "height": 532
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e4371-70e9-73b9-8bd0-6693cf80ad99.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Broadway Chapter logo",
    "public_id": "019e4371-70e9-73b9-8bd0-6693cf80ad99",
    "storage_key": "property/5754272234864640/019e4371-70e9-73b9-8bd0-6693cf80ad99.webp",
    "width": 828,
    "height": 635
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1943-52ab-76cb-8947-3d7be229f685.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1943-52ab-76cb-8947-3d7be229f685",
    "storage_key": "property/5754272234864640/019f1943-52ab-76cb-8947-3d7be229f685.webp",
    "width": 1280,
    "height": 1080
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#f8473a",
  "property_secondary_color": "#f3e9df",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "547 - 1195",
  "property_sqft_min": "547",
  "property_sqft_max": "1195",
  "property_price_range": "1310 - 2385",
  "property_price_min": "1310",
  "property_price_max": "2385",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/broadwaychapter",
  "property_instagram_url": "https://www.instagram.com/broadwaychapter",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGYYSQnVxToYRbPZyqKx3Mrk",
  "property_youtube_url": "https://www.youtube.com/@BroadwayChapterApartments",
  "property_yelp_url": "https://www.yelp.com/biz/broadway-chapter-ft-worth",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that move with the day.</strong> Find focus in Zoom rooms or the resident library, recharge with Peloton, yoga, or a coffee-bar stop, then unwind by the infinity-edge pool with in-pool loungers, sundeck, grills, and a fireside lounge.</p><p>At home, wood-style flooring, stainless steel appliances, walk-in closets, in-home laundry, and keyless fob entry keep daily living polished and simple.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with a little more lift.</strong> Explore studio, one-bedroom, two-bedroom, and loft-style apartments in Fort Worth, with select homes featuring soaring ceilings, oversized windows, private balconies, and expansive views. Stainless steel appliances, wood-style plank flooring, walk-in closets, full-size washer and dryer, and keyless fob entry add everyday ease—browse featured plans, then view them all to find your best fit.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Broadway Chapter in full color.</strong> Browse stainless steel appliances, warm wood-style flooring, oversized windows, and select lofts with soaring height. Then step into the amenities through the lens: an infinity-edge pool with in-pool loungers, fireside seating, a coffee bar, library, fitness studio, bark park, and a bold garage mural that brings art to street level.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Bricktown brings Fort Worth close.</strong> From Broadway Chapter, Magnolia Avenue dining, South Main maker spaces, and Near Southside murals are all part of the everyday route. Grab coffee at Craftwork, head to Fixture or Spice, then keep the day moving toward Amphibian Stage, Rahr &amp; Sons, or Magnolia Green. With Hemphill transit service, I-30, and downtown connections nearby, it’s easy to explore more from 401 Hemphill.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about Broadway Chapter.</strong> Reviews highlight an easy move-in, patient support from the leasing team, and a welcoming community feel from the start. You’ll also see praise for modern apartments, well-kept spaces, pet-friendly details, community events, and a walkable Bricktown location near coffee, dining, gyms, and more—all reasons one resident says Broadway Chapter “sets the standard” for apartment living in DFW.</p>",
  "property_neighborhood_blurb": "<p><strong>Bricktown puts Fort Worth at street level.</strong> From Broadway Chapter, you’re positioned between the neighborhood’s creative corridors—where Magnolia Avenue dining, South Main maker spaces, and Near Southside murals turn quick errands into a reason to linger. Start with coffee at Craftwork, meet up over plates at Fixture or Spice, then follow the map toward Amphibian Stage, Rahr &amp; Sons, or Magnolia Green when the day calls for a show, a pour, or fresh air.</p><p>When you want to range farther, Hemphill transit service, I-30, and nearby downtown connections keep more of Fort Worth within easy reach. Explore what’s around you, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Broadway Chapter fits into the rhythm of the Near Southside.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with a daily rhythm.</strong> At Broadway Chapter, your routine has room to shift—from laps of focus in the Zoom rooms or resident library to a Peloton ride, yoga stretch, or coffee-bar reset. When the day calls for downtime, the infinity-edge pool, in-pool loungers, sundeck, grilling area, and fireside lounge create an easy indoor-outdoor flow.</p><p>Inside your apartment, polished finishes keep everyday living simple: wood-style plank flooring, stainless steel appliances, walk-in closets, full-size washer and dryer, and keyless fob entry. Select homes add loft-style volume, oversized windows, private balconies, or sweeping downtown views. Bring your pet to the bark park, browse the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to start your next Fort Worth chapter?</strong> Apply online for a modern studio, one-bedroom, two-bedroom, or loft-style apartment at Broadway Chapter, where design-forward interiors and inviting resident spaces put home, work, and downtime in easy rhythm.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the Broadway Chapter leasing team for help finding your way to Hemphill Street, learning more about our modern studio, one-bedroom, two-bedroom, and loft-style layouts, or planning your next look at Near Southside apartment living.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Broadway Chapter?</strong> Start here. This FAQ page covers common details about the community, leasing, amenities, and everyday living at Broadway Chapter in Fort Worth’s Near Southside. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that shapes your day.</strong> Broadway Chapter offers studio, one-bedroom, two-bedroom, and loft-style apartments in Fort Worth, giving you options for a streamlined home base, extra room to spread out, or a more dramatic open layout.</p><p>Inside, select the details that matter most: stainless steel appliances, wood-style plank flooring, walk-in closets, full-size washer and dryer, and keyless fob entry. Loft plans add soaring ceilings, while select homes feature oversized windows, private balconies, and expansive views. Browse current availability, compare layouts, and use the floor plan cards to find the home that feels right—then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorites in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces from every angle.</strong> Broadway Chapter’s photo gallery gives you a closer look at the textures, light, and design details that shape these Fort Worth apartments. Picture stainless steel appliances against warm wood-style flooring, oversized windows drawing brightness into open living areas, and select lofts with dramatic height overhead.</p><p>Outside your door, the camera lingers on the infinity-edge pool, in-pool loungers, sundeck, and fireside seating—spaces made for relaxed afternoons and easy evenings. You’ll also catch inviting community scenes, from the coffee bar and lounge to the library, fitness studio, bark park, and the colorful garage mural that adds an artful street-level moment. Browse the images, compare them with our <a href=\"/virtual-tours\">virtual tours</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Broadway Chapter from Hemphill Street.</strong> Use the interactive map to browse available studio, one-bedroom, two-bedroom, and loft-style apartments, then zoom out to see how Near Southside connects you to local dining, breweries, galleries, live music, transit routes, downtown Fort Worth, and I-30.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living that feels easy.</strong> Bring your cat or dog to Broadway Chapter and settle into a home designed for everyday comfort—complete with no weight limit for approved pets and space for up to two companions per apartment. Quick fresh-air breaks are simple with the on-site bark park, while wood-style plank flooring, walk-in closets, and in-home laundry help keep routines tidy after walks, playtime, and rainy-day paws.</p><p>When you want to explore beyond the community, you’re close to neighborhood sidewalks and city dog-park options in Fort Worth, giving your pet more ways to stretch out. See more pet-friendly <a href=\"/amenities\">community amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to picture life here together.</p>",
  "property_referafriend_blurb": "<p><strong>Share your Broadway Chapter.</strong><br>Love the Near Southside energy, design-forward layouts, and days that move from the resident lounge to the infinity-edge pool? Invite a friend to start their next Fort Worth chapter here—send a referral and let them see what makes life on Hemphill Street worth sharing.</p>",
  "property_residentaccess_blurb": "<p><strong>Your Broadway Chapter resident hub.</strong><br>Keep your Near Southside chapter moving with quick access to pay rent, submit maintenance requests, and manage your account—all in one convenient place, so home stays as effortless as the modern living around you.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who live here.</strong> Reviews for Broadway Chapter consistently point to the same things: a smooth, supportive move-in experience, a team that answers questions with patience, and a community that feels genuinely welcoming from day one. Residents call out team members for going above and beyond, from virtual tours that match the real thing to quick help with paperwork and unit changes.</p><p>As you browse the reviews, you’ll also see plenty of love for the details that shape daily life: clean, modern apartments, well-kept spaces, community events, pet-friendly touches, and a walkable Bricktown setting near coffee, restaurants, gyms, and more. As one resident put it, Broadway Chapter “sets the standard” for apartment living in DFW.</p>",
  "property_created_at": "1752256710297",
  "property_scheduletour_blurb": "<p><strong>See Broadway Chapter in person.</strong><br>Tour modern studio, one-bedroom, two-bedroom, and loft-style layouts with oversized windows, wood-style plank flooring, keyless fob entry, and select downtown views—then step into the resident lounge, Zoom rooms, fitness center, and infinity-edge pool deck that bring the Near Southside energy home.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Broadway Chapter’s leasing team will follow up soon. In the meantime, picture modern Near Southside living with design-forward floor plans, oversized windows, resident workspaces, a Peloton-equipped fitness center, and an infinity-edge pool — all connected to the energy of Fort Worth.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through before you walk in.</strong> Start your Broadway Chapter tour from wherever you are and compare the two apartment layouts currently available in 3D: a one-bedroom, one-bath home and a two-bedroom, two-bath home. Move room to room at your own pace, checking the kitchen flow, living area proportions, bedroom placement, closet space, and the everyday details that make a layout feel right.</p><p>As you explore, look for modern finishes like stainless steel appliances, wood-style plank flooring, full-size washer and dryer, keyless fob entry, and natural light from oversized windows. When you’re ready to zoom out from the screen, browse <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Broadway Chapter in Fort Worth in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Broadway Chapter",
  "property_seo_title_home": "Broadway Chapter | Apartments in Fort Worth, TX",
  "property_seo_description_home": "Step into modern living at Broadway Chapter in Fort Worth, TX. Enjoy stylish floor plans, luxurious amenities, and vibrant community vibes. Your new home awaits!",
  "property_seo_title_floorplans": "Find your ideal space at Broadway Chapter in Fort Worth, TX! Choose from stylish studios, one, or two-bedroom layouts. Your perfect home awaits!",
  "property_seo_description_floorplans": "Find your ideal space at Broadway Chapter in Fort Worth, TX. Choose from stylish studios, one-bedroom, or two-bedroom layouts. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Fort Worth, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Broadway Chapter in Fort Worth, TX! Enjoy our vibrant amenities, including a pool, dog park, and fitness center—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Fort Worth, TX",
  "property_seo_description_gallery": "Elevate your lifestyle at Broadway Chapter in Fort Worth, TX! Immerse yourself in stunning floors, modern amenities, and inviting outdoor spaces. Picture your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Broadway Chapter Apartments",
  "property_seo_description_virtualtours": "Step inside Broadway Chapter in Fort Worth, TX! Experience our stunning one and two-bedroom floor plans and studios—take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Broadway Chapter Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Broadway Chapter in Fort Worth, TX! Check out our interactive map for one, two-bedroom, and studio layouts with amazing amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Fort Worth, TX",
  "property_seo_description_neighborhood": "Experience living at Broadway Chapter in Fort Worth, TX! Uncover charming local favorites and hidden gems around our vibrant community. Join us today!",
  "property_seo_title_contact": "Contact Us | Broadway Chapter",
  "property_seo_description_contact": "Connect with Broadway Chapter in Fort Worth, TX for tailored living! Choose from stylish studio, one, or two-bedroom floor plans. Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Fort Worth, TX",
  "property_seo_description_faqs": "Find answers to your questions about Broadway Chapter in Fort Worth, TX. Enjoy top-tier amenities, stunning views, and stylish living. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fort Worth, TX",
  "property_seo_description_reviews": "Experience life at Broadway Chapter in Fort Worth, TX! Check out resident reviews showcasing our stunning amenities, from the poolside views to the dog park bliss.",
  "property_seo_title_applynow": "Apply Now | Apartments in Fort Worth, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Broadway Chapter in Fort Worth, TX. Enjoy modern apartments, enticing amenities, and a vibrant community. Lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Broadway Chapter",
  "property_seo_description_residentaccess": "Unlock seamless living at Broadway Chapter in Fort Worth! Log in to your resident portal for rent payments, maintenance requests, and exclusive community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Broadway Chapter",
  "property_seo_description_referafriend": "\"Refer your friends to Broadway Chapter in Fort Worth! Great neighbors and unforgettable moments await. Share the joy of community living today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Broadway Chapter",
  "property_seo_description_scheduletour": "\"Step into your future at Broadway Chapter in Fort Worth, TX! Experience luxurious living and vibrant community life—schedule your tour today!\"",
  "property_seo_title_privacy": "Privacy Policy | Broadway Chapter",
  "property_seo_description_privacy": "Your privacy matters at Broadway Chapter in Fort Worth. Read our policy to understand how we protect your information while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Broadway Chapter",
  "property_seo_description_accessibility": "Embrace inclusivity at Broadway Chapter in Fort Worth, TX. Our commitment to accessibility ensures every resident can thrive. Join us in creating a welcoming home!",
  "property_seo_title_sitemap": "Sitemap | Broadway Chapter",
  "property_seo_description_sitemap": "Navigate your way through Broadway Chapter in Fort Worth, TX! Check our sitemap to find everything you need about your future home sweet home.",
  "property_seo_title_thankyou": "Thank You | Broadway Chapter",
  "property_seo_description_thankyou": "Thank you for reaching out to Broadway Chapter! Your journey to vibrant Fort Worth living begins here. Expect a warm welcome from our team soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319452",
  "amenities": [
    {
      "id": "ec_3fc702951f459c163c351c32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Infinity Edge Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54a862acca96e64a6349e05a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "In‑Pool Loungers & Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ccb088344eccbaa4dae1026",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center w/ Peleton & Yoga Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e386657da8ef27d6fbc77d62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Lounge w/ Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1dd2524ff9576336e923473",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Community Market",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65514a73b94f6a1cede20aae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Zoom Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c27acdb80f3597a3f41b825a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Library",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c5aec8d4f0f0c5e217807b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Poolside Grilling & Dining Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25f8776d2501c1ef4ce02cba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Community Fireside Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fb48cf65a1036d824a12240",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b215c52a6216c5ebe22b633e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park For Your Furry Friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_457d132f677a29a5c453d0d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b55c0ccbe9ec15ad27ad73e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5205275351dd8acf4911da23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Style Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b9924a83e58e7c006169350",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1907fb15bdf336fd55c33e1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4dc3487f0e9b66ca8f44b89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Full‑Size Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95624cfe0a9f7de5f0f819a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Keyless Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3236a32302a6dcbb4230eaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "20' Ceilings in Lofts",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f70353c269a54f48951a3079",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Oversized Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00f57a9c23485f73420b0b16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Private Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb26c3a86f122543edbfe558",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Downtown Views*",
      "amount": "false",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fca318ca-e4a5-4b20-8d44-2739d2c187ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-a310-7483-86dc-680bc0bf4a56.webp",
      "image_media": {
        "alt_text": "Courtyard seating area and pool.",
        "public_id": "019e8980-a310-7483-86dc-680bc0bf4a56",
        "storage_key": "property/5754272234864640/019e8980-a310-7483-86dc-680bc0bf4a56.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the spacious courtyard with comfortable seating and a refreshing pool.",
      "link": "",
      "alt_text": "Courtyard seating area and pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_04859af6-c99b-4f1d-8d33-a901380d984f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-a359-72b2-a1ef-8e96209546b3.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, stainless steel appliances, and natural light.",
        "public_id": "019e8980-a359-72b2-a1ef-8e96209546b3",
        "storage_key": "property/5754272234864640/019e8980-a359-72b2-a1ef-8e96209546b3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with an island, stainless steel appliances, and a comfortable living room space, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island, stainless steel appliances, and natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa997ee4-d0f4-4ea7-812b-e14daebfb7b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-9b31-763f-8a57-1de15b3fbdba.webp",
      "image_media": {
        "alt_text": "Modern apartment building courtyard with a swimming pool, hot tub, and seating areas.",
        "public_id": "019e8980-9b31-763f-8a57-1de15b3fbdba",
        "storage_key": "property/5754272234864640/019e8980-9b31-763f-8a57-1de15b3fbdba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy resort-style living at our community, featuring a sparkling swimming pool, relaxing hot tub, and beautifully landscaped courtyards perfect for unwinding.",
      "link": "",
      "alt_text": "Modern apartment building courtyard with a swimming pool, hot tub, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c2383d9-47d8-4b97-bac2-7c0b571cf75b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-9b0b-7619-a660-b7dec55c8a79.webp",
      "image_media": {
        "alt_text": "Lobby seating area with modern blue velvet chairs and decorative art.",
        "public_id": "019e8980-9b0b-7619-a660-b7dec55c8a79",
        "storage_key": "property/5754272234864640/019e8980-9b0b-7619-a660-b7dec55c8a79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and modern decor. A perfect space to greet guests or enjoy a quiet moment.",
      "link": "",
      "alt_text": "Lobby seating area with modern blue velvet chairs and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e14d67b0-920b-4cd9-a896-d567485dcd8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-8a59-75f8-a54d-22bf43a75d1e.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, free weights, and a punching bag.",
        "public_id": "019e8980-8a59-75f8-a54d-22bf43a75d1e",
        "storage_key": "property/5754272234864640/019e8980-8a59-75f8-a54d-22bf43a75d1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment to meet all your workout needs.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight machines, free weights, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e2d24de-1b01-42ce-9ef6-d3dc41fdf6d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-88f9-750e-a71f-f87056fd51e0.webp",
      "image_media": {
        "alt_text": "Billiard table and bar area in a community lounge.",
        "public_id": "019e8980-88f9-750e-a71f-f87056fd51e0",
        "storage_key": "property/5754272234864640/019e8980-88f9-750e-a71f-f87056fd51e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community's stylish lounge, featuring a billiard table and a fully equipped bar area for resident use.",
      "link": "",
      "alt_text": "Billiard table and bar area in a community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e201ec5d-11ea-4670-9d36-dd8d9a6e6ae2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-82c1-732f-82df-a413ada894a0.webp",
      "image_media": {
        "alt_text": "Exterior view of Broadway apartment building with colorful mural on adjacent parking garage.",
        "public_id": "019e8980-82c1-732f-82df-a413ada894a0",
        "storage_key": "property/5754272234864640/019e8980-82c1-732f-82df-a413ada894a0.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Exterior view of the Broadway apartments featuring a vibrant mural on the parking garage, showcasing the property's unique aesthetic and urban setting.",
      "link": "",
      "alt_text": "Exterior view of Broadway apartment building with colorful mural on adjacent parking garage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8768bc05-953b-45c0-89b3-14d4b57eb997",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-8456-743a-a1aa-ec6968330af9.webp",
      "image_media": {
        "alt_text": "Modern living room with hanging chair and leather sofa.",
        "public_id": "019e8980-8456-743a-a1aa-ec6968330af9",
        "storage_key": "property/5754272234864640/019e8980-8456-743a-a1aa-ec6968330af9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a hanging rattan chair, a comfortable leather sofa, and a large area rug, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with hanging chair and leather sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d2b57fe8-6463-4d3f-bf3b-c9477d81326f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-87c8-750d-8ba4-988e8939ba51.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, brown tufted headboard, green and black pillows, dresser, plant, and framed art.",
        "public_id": "019e8980-87c8-750d-8ba4-988e8939ba51",
        "storage_key": "property/5754272234864640/019e8980-87c8-750d-8ba4-988e8939ba51.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed with a plush tufted headboard, decorative pillows, a dresser, and elegant artwork, creating a serene and inviting atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a large bed, brown tufted headboard, green and black pillows, dresser, plant, and framed art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed3f53a4-59cf-48dc-b37f-d3d458e692d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-8a64-758e-8e1a-1864134fafe2.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "019e8980-8a64-758e-8e1a-1864134fafe2",
        "storage_key": "property/5754272234864640/019e8980-8a64-758e-8e1a-1864134fafe2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a spacious vanity, modern fixtures, and a relaxing bathtub, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern apartment bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c32f4c0f-48ef-486e-843d-c1e45d75bc32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-851a-736b-9da4-bc163a64217f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray wood cabinets, stainless steel appliances, and an island.",
        "public_id": "019e8980-851a-736b-9da4-bc163a64217f",
        "storage_key": "property/5754272234864640/019e8980-851a-736b-9da4-bc163a64217f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek gray wood cabinetry, high-end stainless steel appliances, and a large island perfect for dining and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with gray wood cabinets, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc5f878e-08af-46ac-9997-b2b76bc74720",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-8790-732f-8187-b840c0b5f0d5.webp",
      "image_media": {
        "alt_text": "Modern apartment building courtyard with a sparkling swimming pool and chaise lounges.",
        "public_id": "019e8980-8790-732f-8187-b840c0b5f0d5",
        "storage_key": "property/5754272234864640/019e8980-8790-732f-8187-b840c0b5f0d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and outdoor lounge area at this vibrant community.",
      "link": "",
      "alt_text": "Modern apartment building courtyard with a sparkling swimming pool and chaise lounges.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_874cbc9d-a4e2-4a10-ad6c-6794306ba2ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-7905-7733-b58d-4f71ee255eab.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dual vanities, a large mirror, and a walk-in shower.",
        "public_id": "019e8980-7905-7733-b58d-4f71ee255eab",
        "storage_key": "property/5754272234864640/019e8980-7905-7733-b58d-4f71ee255eab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring dual vanities with sleek countertops and ample storage, a large illuminated mirror, and a glass-enclosed walk-in shower.",
      "link": "",
      "alt_text": "Modern bathroom with dual vanities, a large mirror, and a walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de6ed88c-2ed9-411b-9cac-de1f59d7938e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-7970-7518-9388-e552e4b9d4d6.webp",
      "image_media": {
        "alt_text": "Luxury lobby seating area with a chandelier, modern art, and plush seating.",
        "public_id": "019e8980-7970-7518-9388-e552e4b9d4d6",
        "storage_key": "property/5754272234864640/019e8980-7970-7518-9388-e552e4b9d4d6.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring elegant decor and comfortable seating perfect for residents and guests.",
      "link": "",
      "alt_text": "Luxury lobby seating area with a chandelier, modern art, and plush seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_beec4c96-c092-4878-8910-d7cf0d916666",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-666b-714a-84c3-5e8fa7ca0070.webp",
      "image_media": {
        "alt_text": "State-of-the-art gym with treadmills, rowing machine, weight machines, punching bag, and dumbbells.",
        "public_id": "019e8980-666b-714a-84c3-5e8fa7ca0070",
        "storage_key": "property/5754272234864640/019e8980-666b-714a-84c3-5e8fa7ca0070.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "State-of-the-art gym with treadmills, rowing machine, weight machines, punching bag, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8652945f-fc7e-40d8-aba4-ddf99fcdcc51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-642d-725d-ac5c-4025c3646c1d.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with pool and seating areas",
        "public_id": "019e8980-642d-725d-ac5c-4025c3646c1d",
        "storage_key": "property/5754272234864640/019e8980-642d-725d-ac5c-4025c3646c1d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy resort-style living with a sparkling pool and comfortable outdoor seating areas in this modern apartment community.",
      "link": "",
      "alt_text": "Apartment complex courtyard with pool and seating areas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1178bff0-8204-462d-9f5a-7f6f657425c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-603f-7744-ae13-2d23ff64b915.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with balconies and signage.",
        "public_id": "019e8980-603f-7744-ae13-2d23ff64b915",
        "storage_key": "property/5754272234864640/019e8980-603f-7744-ae13-2d23ff64b915.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring multiple balconies and prominent leasing signage.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with balconies and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb7995d8-027c-4021-8ddf-850a196cc152",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5ec5-739a-984b-9f9638c5adc1.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and desk.",
        "public_id": "019e8980-5ec5-739a-984b-9f9638c5adc1",
        "storage_key": "property/5754272234864640/019e8980-5ec5-739a-984b-9f9638c5adc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room with a sofa, coffee table, and dedicated workspace, perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6345a9a9-9aaa-46b5-a558-3d2728286c73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5f0b-764d-8ac1-053383f45dff.webp",
      "image_media": {
        "alt_text": "Outdoor patio with two grills, seating areas, and tables.",
        "public_id": "019e8980-5f0b-764d-8ac1-053383f45dff",
        "storage_key": "property/5754272234864640/019e8980-5f0b-764d-8ac1-053383f45dff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and entertaining with built-in grills and comfortable seating areas.",
      "link": "",
      "alt_text": "Outdoor patio with two grills, seating areas, and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6aafa016-ff0f-413b-996e-fcd5c51f5c5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5fb1-731d-b8ba-397edf73aab7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island, and light wood cabinets.",
        "public_id": "019e8980-5fb1-731d-b8ba-397edf73aab7",
        "storage_key": "property/5754272234864640/019e8980-5fb1-731d-b8ba-397edf73aab7.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and contemporary kitchen featuring sleek stainless steel appliances, ample cabinet space, and a large island perfect for casual dining. This fully equipped kitchen is designed for both style and functionality.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island, and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb1e2211-1755-4e23-9db7-78da47dcf581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5e13-77c9-8acc-533561007e65.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dual vanity, toilet, and bathtub.",
        "public_id": "019e8980-5e13-77c9-8acc-533561007e65",
        "storage_key": "property/5754272234864640/019e8980-5e13-77c9-8acc-533561007e65.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern bathroom featuring a dual vanity, elegant fixtures, and a relaxing bathtub. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a dual vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13cdf458-e428-49f0-9019-47c4077dd48a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5fb3-77c1-b52f-21d2edfc4b24.webp",
      "image_media": {
        "alt_text": "A modern kitchenette area with a coffee maker, sink, and snacks.",
        "public_id": "019e8980-5fb3-77c1-b52f-21d2edfc4b24",
        "storage_key": "property/5754272234864640/019e8980-5fb3-77c1-b52f-21d2edfc4b24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our resident refreshment station.",
      "link": "",
      "alt_text": "A modern kitchenette area with a coffee maker, sink, and snacks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13180d8a-5f34-45a2-9c2f-0fe1d7bcd59d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5fa9-7111-b4c5-ef9dbdf17f3f.webp",
      "image_media": {
        "alt_text": "Lobby seating area with tufted booths and a long dining table.",
        "public_id": "019e8980-5fa9-7111-b4c5-ef9dbdf17f3f",
        "storage_key": "property/5754272234864640/019e8980-5fa9-7111-b4c5-ef9dbdf17f3f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The communal lobby area features comfortable tufted booths and a large dining table, perfect for resident gatherings.",
      "link": "",
      "alt_text": "Lobby seating area with tufted booths and a long dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f90b6b8-0e6a-4364-8a45-57e7a255dd1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-5fa4-740e-a1d7-011f5fba1a6c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, large artwork, and a dresser with a mirror.",
        "public_id": "019e8980-5fa4-740e-a1d7-011f5fba1a6c",
        "storage_key": "property/5754272234864640/019e8980-5fa4-740e-a1d7-011f5fba1a6c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed, elegant decor, and ample natural light. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, large artwork, and a dresser with a mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f5decfd-51e0-4dbf-a8b6-95bbe72db47b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-4c4c-70cb-8e53-871dc4ad7a46.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with leather chairs and abstract art.",
        "public_id": "019e8980-4c4c-70cb-8e53-871dc4ad7a46",
        "storage_key": "property/5754272234864640/019e8980-4c4c-70cb-8e53-871dc4ad7a46.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring plush seating and modern decor.",
      "link": "",
      "alt_text": "Comfortable seating area with leather chairs and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7277390-8f55-4e91-84a9-b9c79686a087",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-3cd4-70bd-b732-d013030b5cbf.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, weight machines, free weights, punching bag, and trampoline.",
        "public_id": "019e8980-3cd4-70bd-b732-d013030b5cbf",
        "storage_key": "property/5754272234864640/019e8980-3cd4-70bd-b732-d013030b5cbf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with everything you need for a complete workout.",
      "link": "",
      "alt_text": "Modern fitness center with treadmills, weight machines, free weights, punching bag, and trampoline.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_747a0888-5ee0-4b8d-8a97-e4ad6651dd64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e8980-3489-73b3-bd9a-92e06bed6199.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, featuring a striking Texas Longhorn artwork above the headboard.",
        "public_id": "019e8980-3489-73b3-bd9a-92e06bed6199",
        "storage_key": "property/5754272234864640/019e8980-3489-73b3-bd9a-92e06bed6199.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom retreat featuring a plush king-size bed and unique Texas Longhorn wall art, offering a stylish and comfortable living space.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, featuring a striking Texas Longhorn artwork above the headboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_b76c0ef1c18ca8f28f44de08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Proper",
      "poi_type": "Restaurants",
      "poi_address": "409 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Classic & modern cocktails prepared in an intimate, speakeasy-inspired nook with a quaint patio.",
      "poi_long_description": "Classic & modern cocktails prepared in an intimate, speakeasy-inspired nook with a quaint patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-d8eb-75cb-8618-6f5af153641c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-d8eb-75cb-8618-6f5af153641c",
        "storage_key": "property/5754272234864640/019f1513-d8eb-75cb-8618-6f5af153641c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://propermagnolia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17071522505199697633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "proper",
      "poi_latitude": "32.7304869",
      "poi_longitude": "-97.3294086",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-984-1133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f52-7719-b301-88ce69f619f9",
        "storage_key": "property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4EQugpxToYR4b6DCUU76uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "ec_32ee1276738147cea11fdce5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fixture - Kitchen and Social Lounge",
      "poi_type": "Restaurants",
      "poi_address": "American Restaurant, 401 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Refined comfort foods & craft cocktails in a hip, industrial-chic space with outdoor seating.",
      "poi_long_description": "Refined comfort foods & craft cocktails in a hip, industrial-chic space with outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-dd89-77b8-bdd0-eb1449157392.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-dd89-77b8-bdd0-eb1449157392",
        "storage_key": "property/5754272234864640/019f1513-dd89-77b8-bdd0-eb1449157392.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fixturefw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10413547268754328278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fixture---kitchen-and-social-lounge",
      "poi_latitude": "32.730504",
      "poi_longitude": "-97.3292551",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-708-2663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f52-7719-b301-88ce69f619f9",
        "storage_key": "property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOQEOvApxToYR1krXTRFahJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lounge_bar"
    },
    {
      "id": "ec_05c34916aa39065e5467d793",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Spiral Diner & Bakery",
      "poi_type": "Restaurants",
      "poi_address": "1314 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Branch of a small chain offering creative, organic-leaning vegan fare in funky, retro-themed digs.",
      "poi_long_description": "Branch of a small chain offering creative, organic-leaning vegan fare in funky, retro-themed digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-d958-72cc-b110-53f7ae4a0d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-d958-72cc-b110-53f7ae4a0d2d",
        "storage_key": "property/5754272234864640/019f1513-d958-72cc-b110-53f7ae4a0d2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spiraldiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5027840537525626478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spiral-diner--bakery",
      "poi_latitude": "32.7308298",
      "poi_longitude": "-97.340086",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-332-8834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3WQkXdxToYRbiaGilR6xkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "ec_f0275002b4dfc719d4dde9d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Pie Tap Pizza + Rotisserie + Bar",
      "poi_type": "Restaurants",
      "poi_address": "1301 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-de65-7469-a580-c3c5eaf44baa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-de65-7469-a580-c3c5eaf44baa",
        "storage_key": "property/5754272234864640/019f1513-de65-7469-a580-c3c5eaf44baa.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.pie-tap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17739280616506848464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pie-tap-pizza--rotisserie--bar",
      "poi_latitude": "32.7305212",
      "poi_longitude": "-97.3395376",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-707-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2Hz5KlxToYR0PTc5buVLvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_7b2c2cfd0b4b670f136469c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Paris Coffee Shop",
      "poi_type": "Restaurants",
      "poi_address": "704 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Coffee shop for breakfasts and lunches with a wide dessert menu specialising in pies.",
      "poi_long_description": "Coffee shop for breakfasts and lunches with a wide dessert menu specialising in pies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-dd95-721e-9aa3-2dd95020acc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-dd95-721e-9aa3-2dd95020acc7",
        "storage_key": "property/5754272234864640/019f1513-dd95-721e-9aa3-2dd95020acc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pariscoffeeshopfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16161675431762260169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paris-coffee-shop",
      "poi_latitude": "32.73087599999999",
      "poi_longitude": "-97.331914",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-945-1702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6e8a3VxToYRyfBYTS3OSeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "ec_e0258cf84882a4c64ab6f23a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Shaw's Patio Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1051 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Wood-lined saloon features a menu of hearty bar fare, twin patios & weekend live music.",
      "poi_long_description": "Wood-lined saloon features a menu of hearty bar fare, twin patios & weekend live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-dcca-7411-9957-016919d6ced8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-dcca-7411-9957-016919d6ced8",
        "storage_key": "property/5754272234864640/019f1513-dcca-7411-9957-016919d6ced8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.shawspatio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9449711057277519132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shaws-patio-bar--grill",
      "poi_latitude": "32.7304719",
      "poi_longitude": "-97.3362157",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-926-2116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f52-7719-b301-88ce69f619f9",
        "storage_key": "property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk0IhE3ZxToYRHIUbzyMeJIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_bbffdcd63b0b6a262eba6227",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "FELINA",
      "poi_type": "Restaurants",
      "poi_address": "401 Bryan Ave Unit 117, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-d95a-74bf-b81a-7289b6f6324d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-d95a-74bf-b81a-7289b6f6324d",
        "storage_key": "property/5754272234864640/019f1513-d95a-74bf-b81a-7289b6f6324d.webp",
        "width": 975,
        "height": 1280
      },
      "poi_business_url": "https://www.felinatx.com/?utm_content=link_in_bio",
      "poi_directions_map_url": "https://maps.google.com/?cid=11382169007222302525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "felina",
      "poi_latitude": "32.7402085",
      "poi_longitude": "-97.3248775",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-507-8626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWmYx1BxToYRPSfyIGiW9Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_bd0f0cb5c7f12bb2af0109db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Bocca Osteria Romana Fort Worth",
      "poi_type": "Restaurants",
      "poi_address": "411 S Main St Unit 104, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-de51-77b4-b863-ff29e3510c02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-de51-77b4-b863-ff29e3510c02",
        "storage_key": "property/5754272234864640/019f1513-de51-77b4-b863-ff29e3510c02.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.boccaftw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6551969461241002244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bocca-osteria-romana-fort-worth",
      "poi_latitude": "32.7407497",
      "poi_longitude": "-97.325363",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-386-4812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0sqPqxxToYRBDl63IJF7Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ddf7287cc189e90a846a9fbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Cane Rosso",
      "poi_type": "Restaurants",
      "poi_address": "815 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Pizzeria specializing in wood-fired Neapolitan pies. plus Italian sandwiches, pastas & desserts.",
      "poi_long_description": "Pizzeria specializing in wood-fired Neapolitan pies. plus Italian sandwiches, pastas & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-d8bd-7410-a6e9-67073552dc97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-d8bd-7410-a6e9-67073552dc97",
        "storage_key": "property/5754272234864640/019f1513-d8bd-7410-a6e9-67073552dc97.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.canerosso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11606905431736416543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cane-rosso",
      "poi_latitude": "32.7304943",
      "poi_longitude": "-97.3331916",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-922-9222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKW01mXVxToYRH3kzgP4CFKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_9eb79a87eddaa37a7d508d47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "The Boiled Owl Tavern",
      "poi_type": "Restaurants",
      "poi_address": "909 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Dark and inviting hangout featuring live music and karaoke, as well as a pool table and a patio.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-dba9-7238-8598-63c0cfea78a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-dba9-7238-8598-63c0cfea78a8",
        "storage_key": "property/5754272234864640/019f1513-dba9-7238-8598-63c0cfea78a8.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8169572401983840271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boiled-owl-tavern",
      "poi_latitude": "32.7304173",
      "poi_longitude": "-97.3337335",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-920-9616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f52-7719-b301-88ce69f619f9",
        "storage_key": "property/5754272234864640/019f1514-1f52-7719-b301-88ce69f619f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eg8kXVxToYRD-AUu9AmYHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_337a914a588e1e1bb5de9196",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Spice",
      "poi_type": "Restaurants",
      "poi_address": "411 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "Traditional Thai noodle dishes, curries & stir-fries served in a colorful, contemporary space.",
      "poi_long_description": "Traditional Thai noodle dishes, curries & stir-fries served in a colorful, contemporary space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e4fc-711c-90a6-8db1937a9209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e4fc-711c-90a6-8db1937a9209",
        "storage_key": "property/5754272234864640/019f1513-e4fc-711c-90a6-8db1937a9209.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.spicedfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7490542795832482539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spice",
      "poi_latitude": "32.7305145",
      "poi_longitude": "-97.3294796",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-984-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsU96sApxToYR69p0ePzA82c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_3ade97299cdd943b21d01290",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Walloon's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "701 W Magnolia Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "From-scratch seafood dishes, small plates, and wine are presented in a historic bank building.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e4a3-71a8-b3ba-d9975d747369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e4a3-71a8-b3ba-d9975d747369",
        "storage_key": "property/5754272234864640/019f1513-e4a3-71a8-b3ba-d9975d747369.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://walloonsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2855163764490099529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walloons-restaurant",
      "poi_latitude": "32.7304814",
      "poi_longitude": "-97.3318177",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-224-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUNhyV5xToYRSdv_BVGUnyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5e454e518e21e2414bec5911",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Panther City BBQ",
      "poi_type": "Restaurants",
      "poi_address": "201 E Hattie St, Fort Worth, TX 76104, USA",
      "poi_short_description": "Oak-smoked meats, Southern & Tex-Mex sides & banana pudding are dispensed from a food truck.",
      "poi_long_description": "Oak-smoked meats, Southern & Tex-Mex sides & banana pudding are dispensed from a food truck.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e896-7775-989e-9289575044b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e896-7775-989e-9289575044b9",
        "storage_key": "property/5754272234864640/019f1513-e896-7775-989e-9289575044b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://panthercitybbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15595074753480169803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panther-city-bbq",
      "poi_latitude": "32.7381809",
      "poi_longitude": "-97.3247504",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 682-250-4464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8bKwxxToYRSxnZrtzVbNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_e4d7634a5d9ba36f3b93df6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "La Playa Maya Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3200 Hemphill St, Fort Worth, TX 76110, USA",
      "poi_short_description": "Casual Mexican chain member with a broad menu of traditional & contemporary fare in a cozy space.",
      "poi_long_description": "Casual Mexican chain member with a broad menu of traditional & contemporary fare in a cozy space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e6a9-74f1-b4ed-7b42c87b5122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e6a9-74f1-b4ed-7b42c87b5122",
        "storage_key": "property/5754272234864640/019f1513-e6a9-74f1-b4ed-7b42c87b5122.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://laplayamaya.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17071089848815958202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-playa-maya-mexican-restaurant",
      "poi_latitude": "32.7039444",
      "poi_longitude": "-97.3319306",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-924-0698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRHlWOpxToYRurhzX8Wx6Ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_bb0a7dca5e46d429a3690f55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Teddy Wongs - Dumplings & Wine",
      "poi_type": "Restaurants",
      "poi_address": "812 W Rosedale St, Fort Worth, TX 76104, USA",
      "poi_short_description": "Trendy eatery serving creative cocktails and a variety of dumplings, along with Chinese fare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e9bc-74e6-9f83-fd3f521fe26f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e9bc-74e6-9f83-fd3f521fe26f",
        "storage_key": "property/5754272234864640/019f1513-e9bc-74e6-9f83-fd3f521fe26f.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://teddywongs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11021966606977031094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teddy-wongs---dumplings--wine",
      "poi_latitude": "32.7334416",
      "poi_longitude": "-97.3330534",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-349-8965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-35a13b495e1b",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-35a13b495e1b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbTAk5hxToYRtlsVbzvk9Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "ec_781f7562a14dffad07acc280",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "1101 Hemphill St, Fort Worth, TX 76104, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e4b7-778d-b687-f490a540975b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e4b7-778d-b687-f490a540975b",
        "storage_key": "property/5754272234864640/019f1513-e4b7-778d-b687-f490a540975b.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/fort-worth/1101-hemphill-st?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1NjItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12725817235745835209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.7327069",
      "poi_longitude": "-97.3313031",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-334-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f5b-7796-a11a-306ee0f05745.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f5b-7796-a11a-306ee0f05745",
        "storage_key": "property/5754272234864640/019f1514-1f5b-7796-a11a-306ee0f05745.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJY2d63XRxToYRyYgsBVovm7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_9d2391c5f608745ebac1f505",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1622 Hemphill St, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e577-77e8-93c7-342dbd125064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e577-77e8-93c7-342dbd125064",
        "storage_key": "property/5754272234864640/019f1513-e577-77e8-93c7-342dbd125064.webp",
        "width": 1157,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/fort-worth/1622-hemphill-@-allen-18746",
      "poi_directions_map_url": "https://maps.google.com/?cid=13630305279725254860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.7262525",
      "poi_longitude": "-97.3320873",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-924-6261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f62-7768-9820-8de60b124616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f62-7768-9820-8de60b124616",
        "storage_key": "property/5754272234864640/019f1514-1f62-7768-9820-8de60b124616.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJM4t4UIJxToYRzLgnem-SKL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_4b21b5126972971fffcee6fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1115 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e9af-716d-91c1-a534ad167294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e9af-716d-91c1-a534ad167294",
        "storage_key": "property/5754272234864640/019f1513-e9af-716d-91c1-a534ad167294.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fort-worth-tx-pharmacies/1115-8th-avenue-fort-worth-tx-76104/storeid=11323?WT.mc_id=LS_GOOGLE_RX_11323",
      "poi_directions_map_url": "https://maps.google.com/?cid=5788496377098122102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.7325488",
      "poi_longitude": "-97.3434808",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-806-1094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f8e-753a-9983-f8600231da6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f8e-753a-9983-f8600231da6d",
        "storage_key": "property/5754272234864640/019f1514-1f8e-753a-9983-f8600231da6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwLwGKlxToYRdrORRMneVFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3bd106f64c55e492ba4c8624",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Evans Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "2019 Evans Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13575762616892817680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evans-food-mart",
      "poi_latitude": "32.7229255",
      "poi_longitude": "-97.3180122",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-926-2777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f62-7768-9820-8de60b124616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f62-7768-9820-8de60b124616",
        "storage_key": "property/5754272234864640/019f1514-1f62-7768-9820-8de60b124616.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJw0w4aa9xToYREIHsLizMZrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_db49675797b8161f6a86f382",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Macarena Grocery Store and Smoke Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "3750 Hemphill St, Fort Worth, TX 76110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-eae6-70dd-8728-04299911c872.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-eae6-70dd-8728-04299911c872",
        "storage_key": "property/5754272234864640/019f1513-eae6-70dd-8728-04299911c872.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13985382413539001506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macarena-grocery-store-and-smoke-shop",
      "poi_latitude": "32.6938551",
      "poi_longitude": "-97.3320225",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-923-7717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f62-7768-9820-8de60b124616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f62-7768-9820-8de60b124616",
        "storage_key": "property/5754272234864640/019f1514-1f62-7768-9820-8de60b124616.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJv56UuudxToYRosT8FjUPFsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_20123fa1135d6b2fedb3bf63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "717 W Berry St, Fort Worth, TX 76110, USA",
      "poi_short_description": "Grocery and discount retailer for a variety of products and food items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-eb50-7719-86be-f859329c4d77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-eb50-7719-86be-f859329c4d77",
        "storage_key": "property/5754272234864640/019f1513-eb50-7719-86be-f859329c4d77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3135-fort-worth-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17718494992100795409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.704419",
      "poi_longitude": "-97.3323404",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-840-0262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4efa-7308-9f74-c2fea614d6cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4efa-7308-9f74-c2fea614d6cc",
        "storage_key": "property/5754272234864640/019f1511-4efa-7308-9f74-c2fea614d6cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85625OpxToYREaS0llG95PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_47d856eaaa99de4f130cce8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "3906 Hemphill St, Fort Worth, TX 76110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ea2c-702d-a610-1048a1a719a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ea2c-702d-a610-1048a1a719a5",
        "storage_key": "property/5754272234864640/019f1513-ea2c-702d-a610-1048a1a719a5.webp",
        "width": 460,
        "height": 300
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1632112265939038231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "32.690701",
      "poi_longitude": "-97.332648",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4efa-7308-9f74-be653ad09d79",
        "storage_key": "property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJekpKgBxToYRF7DaZHVtphY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_4b73adaf9069119938c38745",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Southtown Shopping Center, 3033 South Fwy, Fort Worth, TX 76104, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ece8-701e-801f-9f3ad74db478.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ece8-701e-801f-9f3ad74db478",
        "storage_key": "property/5754272234864640/019f1513-ece8-701e-801f-9f3ad74db478.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.familydollar.com/tx/fort-worth/3033-south-freeway?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17899388341369282789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "32.7077483",
      "poi_longitude": "-97.3191656",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 682-200-3940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4efa-7308-9f74-be653ad09d79",
        "storage_key": "property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXYn9w8dxToYR5aAViNxmZ_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_1abc395c08aacb815abbeca8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 Carroll St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ee05-708a-a6bc-97dd57e155da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ee05-708a-a6bc-97dd57e155da",
        "storage_key": "property/5754272234864640/019f1513-ee05-708a-a6bc-97dd57e155da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/fort-worth-central/2042",
      "poi_directions_map_url": "https://maps.google.com/?cid=2347053527036675256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.7559145",
      "poi_longitude": "-97.3533438",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-302-0290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4efa-7308-9f74-be653ad09d79",
        "storage_key": "property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM6RJeOFzToYRuETZY79okiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_bf6ffb9e43a8ff1adc13ac0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W 7th St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Well-stocked grocery store providing beer and wine, plus a bakery, deli and pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ef2c-7438-958a-1d030b285308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ef2c-7438-958a-1d030b285308",
        "storage_key": "property/5754272234864640/019f1513-ef2c-7438-958a-1d030b285308.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.tomthumb.com/tx/fort-worth/2400-w-7th-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15789310397442528209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "32.7514911",
      "poi_longitude": "-97.3513019",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-302-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4efa-7308-9f74-c2fea614d6cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4efa-7308-9f74-c2fea614d6cc",
        "storage_key": "property/5754272234864640/019f1511-4efa-7308-9f74-c2fea614d6cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2mc-19xToYR0ZPxrybmHts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_31ec535ae6cf125511f3b1be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "[CLOSED] De Zavala Elementary School (FWISD)",
      "poi_type": "Education",
      "poi_address": "1419 College Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f138-738d-9462-606ccd0a55ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f138-738d-9462-606ccd0a55ed",
        "storage_key": "property/5754272234864640/019f1513-f138-738d-9462-606ccd0a55ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fwisd.org/about/betterspaces",
      "poi_directions_map_url": "https://maps.google.com/?cid=18364469498105482755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "closed-de-zavala-elementary-school-fwisd",
      "poi_latitude": "32.7289021",
      "poi_longitude": "-97.3347011",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-814-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQwqmEZ5xToYRA84Sm7Wz2_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e706b72f6761af91421903c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Daggett Middle School (FWISD)",
      "poi_type": "Education",
      "poi_address": "1108 Carlock St, Fort Worth, TX 76110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f131-7496-aaa4-c5af2a9c25e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f131-7496-aaa4-c5af2a9c25e4",
        "storage_key": "property/5754272234864640/019f1513-f131-7496-aaa4-c5af2a9c25e4.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://daggettmiddle.fwisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15366781717193435002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daggett-middle-school-fwisd",
      "poi_latitude": "32.7189122",
      "poi_longitude": "-97.3374902",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-814-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS_6aW5pxToYReidIGo7GQdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_92747d8d72b011e9c6b50b32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "R.L. Paschal High School (FWISD)",
      "poi_type": "Education",
      "poi_address": "3001 Forest Park Blvd, Fort Worth, TX 76110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f144-754c-a7fa-5106902706d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f144-754c-a7fa-5106902706d9",
        "storage_key": "property/5754272234864640/019f1513-f144-754c-a7fa-5106902706d9.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.fwisd.org/Paschal",
      "poi_directions_map_url": "https://maps.google.com/?cid=5670716808103772685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rl-paschal-high-school-fwisd",
      "poi_latitude": "32.7079315",
      "poi_longitude": "-97.3503671",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-814-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6wu5kYpxToYRDcLcaORusk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_838a9517cab3342db2bf6f4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Tarrant County College - Trinity River Campus",
      "poi_type": "Education",
      "poi_address": "300 Trinity Campus Cir, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-2133-76be-bfa9-192c87b3614a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-2133-76be-bfa9-192c87b3614a",
        "storage_key": "property/5754272234864640/019f1511-2133-76be-bfa9-192c87b3614a.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.tccd.edu/locations/trinity-river-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9504033172620395573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---trinity-river-campus",
      "poi_latitude": "32.7568134",
      "poi_longitude": "-97.3377362",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx75YhhRxToYRNUSR49Ab5YM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3d0eafb627949d7e04922659",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Texas A&M University School of Law",
      "poi_type": "Education",
      "poi_address": "1515 Commerce St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f1f6-772b-a025-a3aeb92d1e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f1f6-772b-a025-a3aeb92d1e36",
        "storage_key": "property/5754272234864640/019f1513-f1f6-772b-a025-a3aeb92d1e36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://law.tamu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16609121471263198399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-am-university-school-of-law",
      "poi_latitude": "32.7486262",
      "poi_longitude": "-97.3255312",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-212-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIRUhPxRxToYRv8z0rfpzf-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_3738a07d93231c4ed92b24a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Baylor Scott & White Health, All Saints Children's Campus",
      "poi_type": "Education",
      "poi_address": "1709 N Enderly Pl, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f32a-76fd-83fd-c36c7deac43b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f32a-76fd-83fd-c36c7deac43b",
        "storage_key": "property/5754272234864640/019f1513-f32a-76fd-83fd-c36c7deac43b.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/tx/fort-worth/1709-n-enderly-place-76104?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=15139942037558042571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-health-all-saints-childrens-campus",
      "poi_latitude": "32.7282613",
      "poi_longitude": "-97.3460365",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-502-6467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJheRHMYJxToYRy5-mfBHhG9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_64b0bc06d4cb45113734fbdb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Center for Transforming Lives Polytechnic Child Development Center",
      "poi_type": "Education",
      "poi_address": "3401 Avenue I, Fort Worth, TX 76105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f689-70af-9098-dee8371d5096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f689-70af-9098-dee8371d5096",
        "storage_key": "property/5754272234864640/019f1513-f689-70af-9098-dee8371d5096.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.transforminglives.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6988027165648412792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-transforming-lives-polytechnic-child-development-center",
      "poi_latitude": "32.7282251",
      "poi_longitude": "-97.2763313",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-536-1731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUKNS2NwToYReOBA2a51-mA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_b29b273d0a566f23b790dd4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Trimble Technical High School (FWISD)",
      "poi_type": "Education",
      "poi_address": "1003 W Cannon St, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f626-7252-a9b0-2664f89e9799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f626-7252-a9b0-2664f89e9799",
        "storage_key": "property/5754272234864640/019f1513-f626-7252-a9b0-2664f89e9799.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "https://www.fwisd.org/TrimbleTech",
      "poi_directions_map_url": "https://maps.google.com/?cid=9593013583526366072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trimble-technical-high-school-fwisd",
      "poi_latitude": "32.7367362",
      "poi_longitude": "-97.336174",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-815-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl3pERHFxToYReAuWOwc7IYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9fed680c2a1c77a1e8fd2e07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "UNT Health Fort Worth",
      "poi_type": "Education",
      "poi_address": "3500 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f4c2-74f9-9095-55bfb43baced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f4c2-74f9-9095-55bfb43baced",
        "storage_key": "property/5754272234864640/019f1513-f4c2-74f9-9095-55bfb43baced.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.unthealth.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001576964368720476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unt-health-fort-worth",
      "poi_latitude": "32.7496982",
      "poi_longitude": "-97.3694771",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-735-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQcyAaOpzToYRXGKpviu88es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_e2e1a76d66f35ee3672913f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Texas Christian University",
      "poi_type": "Education",
      "poi_address": "2800 S University Dr, Fort Worth, TX 76109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-1e22-7196-a125-5551a443b280.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-1e22-7196-a125-5551a443b280",
        "storage_key": "property/5754272234864640/019f1511-1e22-7196-a125-5551a443b280.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=375771055333629936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-christian-university",
      "poi_latitude": "32.7078531",
      "poi_longitude": "-97.3628041",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-257-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_b0MPT1yToYR8N8IrsgBNwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_841afe7621a08e0ea1e0bde8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Bass Performance Hall",
      "poi_type": "Entertainment",
      "poi_address": "525 Commerce St, Fort Worth, TX 76102, USA",
      "poi_short_description": "Elegant performing arts venue with multi-tiered seating for concerts, plays & other entertainment.",
      "poi_long_description": "Elegant performing arts venue with multi-tiered seating for concerts, plays & other entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f7d5-7209-9b78-56af766fe1b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f7d5-7209-9b78-56af766fe1b5",
        "storage_key": "property/5754272234864640/019f1513-f7d5-7209-9b78-56af766fe1b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.basshall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=935070752829437600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bass-performance-hall",
      "poi_latitude": "32.7548751",
      "poi_longitude": "-97.3298805",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-212-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXV_pgT9xToYRoHZBPuUJ-gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_eebc9c58a92b2d839e7c6331",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth Water Gardens",
      "poi_type": "Entertainment",
      "poi_address": "1502 Commerce St, Fort Worth, TX 76102, USA",
      "poi_short_description": "Tranquil Philip Johnson-designed urban park featuring 4.3 acres of waterfalls, pools & fountains.",
      "poi_long_description": "Tranquil Philip Johnson-designed urban park featuring 4.3 acres of waterfalls, pools & fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f633-760e-a321-19278ca66394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f633-760e-a321-19278ca66394",
        "storage_key": "property/5754272234864640/019f1513-f633-760e-a321-19278ca66394.webp",
        "width": 1200,
        "height": 804
      },
      "poi_business_url": "http://www.fortworth.com/things-to-do/attractions/fort-worth-water-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13328630581232758923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-water-gardens",
      "poi_latitude": "32.747749",
      "poi_longitude": "-97.32663",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-392-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqj5xToYRi3DJQOXO-Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_876a365b1a94f0a2a4437a2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Sundance Square",
      "poi_type": "Entertainment",
      "poi_address": "420 Main St, Fort Worth, TX 76102, USA",
      "poi_short_description": "Various retailers & restaurants with outdoor dining are offered around this lively square.",
      "poi_long_description": "Various retailers & restaurants with outdoor dining are offered around this lively square.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f8f9-71dd-be37-a4b140a01ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f8f9-71dd-be37-a4b140a01ae2",
        "storage_key": "property/5754272234864640/019f1513-f8f9-71dd-be37-a4b140a01ae2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sundancesquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10464284928673661027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sundance-square",
      "poi_latitude": "32.7546342",
      "poi_longitude": "-97.3314968",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-222-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4efa-7308-9f74-be653ad09d79",
        "storage_key": "property/5754272234864640/019f1511-4efa-7308-9f74-be653ad09d79.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9R1G70BxToYRY0ARUrObOJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_51117a493d680554d9fd6db7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Scat Jazz Lounge",
      "poi_type": "Entertainment",
      "poi_address": "111 W 4th St #11, Fort Worth, TX 76102, USA",
      "poi_short_description": "Live jazz from local & national talent in a speakeasy-style club tucked into a subterranean space.",
      "poi_long_description": "Live jazz from local & national talent in a speakeasy-style club tucked into a subterranean space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-fa2f-71db-b5f7-e7176b391d5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-fa2f-71db-b5f7-e7176b391d5f",
        "storage_key": "property/5754272234864640/019f1513-fa2f-71db-b5f7-e7176b391d5f.webp",
        "width": 700,
        "height": 500
      },
      "poi_business_url": "https://scatjazzlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14073575284126673728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scat-jazz-lounge",
      "poi_latitude": "32.7540707",
      "poi_longitude": "-97.331422",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-870-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRgoXUBxToYRQGsW6idiT8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_9e68d608e43b9cb25e0ead13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Sid Richardson Museum",
      "poi_type": "Entertainment",
      "poi_address": "309 Main St, Fort Worth, TX 76102, USA",
      "poi_short_description": "Small museum displaying Wild West paintings of Charles M. Russell, Frederic Remington & more.",
      "poi_long_description": "Small museum displaying Wild West paintings of Charles M. Russell, Frederic Remington & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-fc33-75f7-ba47-6f353e7c79b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-fc33-75f7-ba47-6f353e7c79b6",
        "storage_key": "property/5754272234864640/019f1513-fc33-75f7-ba47-6f353e7c79b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sidrichardsonmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9190831284134500943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sid-richardson-museum",
      "poi_latitude": "32.755518",
      "poi_longitude": "-97.331553",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-332-6554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQoD7kBxToYRT1pimVtkjH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_a8395519b6c0bc48eef5c226",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Kimbell Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "3333 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_long_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-2b6e-70ea-bcf2-11872d90d4e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-2b6e-70ea-bcf2-11872d90d4e6",
        "storage_key": "property/5754272234864640/019f1511-2b6e-70ea-bcf2-11872d90d4e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kimbellart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239859824201680144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimbell-art-museum",
      "poi_latitude": "32.7485687",
      "poi_longitude": "-97.3649208",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-332-8451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_3ggMJzToYREMUp1SYmeWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_5645d498d4a922e505450b95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Modern Art Museum of Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3200 Darnell St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_long_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ff49-7591-8136-94090a4018b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ff49-7591-8136-94090a4018b2",
        "storage_key": "property/5754272234864640/019f1513-ff49-7591-8136-94090a4018b2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.themodern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12620084409265249041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "modern-art-museum-of-fort-worth",
      "poi_latitude": "32.7491803",
      "poi_longitude": "-97.3633072",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-738-9215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5w_isJzToYREVuz-eeLI68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_d2160a6ea9cab6322fa99930",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Amon Carter Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "3501 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_long_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ffa1-75cf-b059-295dea9e63b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ffa1-75cf-b059-295dea9e63b9",
        "storage_key": "property/5754272234864640/019f1513-ffa1-75cf-b059-295dea9e63b9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cartermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2896534922228772865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amon-carter-museum-of-american-art",
      "poi_latitude": "32.747867",
      "poi_longitude": "-97.368447",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-738-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcQcjcFzToYRAbD1TiqPMig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_8f7268f7e67434455530a680",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth Museum of Science and History",
      "poi_type": "Entertainment",
      "poi_address": "1600 Gendy St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Hands-on science exhibits, a planetarium & IMAX films in a large-scale, child-friendly venue.",
      "poi_long_description": "Hands-on science exhibits, a planetarium & IMAX films in a large-scale, child-friendly venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-2a21-71a5-ab10-9154e2e1758f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-2a21-71a5-ab10-9154e2e1758f",
        "storage_key": "property/5754272234864640/019f1511-2a21-71a5-ab10-9154e2e1758f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fwmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3157640673865477658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-museum-of-science-and-history",
      "poi_latitude": "32.7441334",
      "poi_longitude": "-97.3692048",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-255-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-dqJcFzToYRGq4ThnYx0is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_81d90cda0e8ef027b593b076",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Dickies Arena",
      "poi_type": "Entertainment",
      "poi_address": "1911 Montgomery St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Venue hosting concerts and other live events, including rodeos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-25f7-710b-be7f-dc2af53692bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-25f7-710b-be7f-dc2af53692bd",
        "storage_key": "property/5754272234864640/019f1511-25f7-710b-be7f-dc2af53692bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.dickiesarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14930229685278085321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dickies-arena",
      "poi_latitude": "32.7410208",
      "poi_longitude": "-97.3689566",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-402-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyrGicZzToYRyRD-hcvUMs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_04da0f6e7ffa9a2bc943cfab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hospital Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 Pennsylvania Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-3576-74d6-80cf-bf4153441bdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-3576-74d6-80cf-bf4153441bdc",
        "storage_key": "property/5754272234864640/019f1511-3576-74d6-80cf-bf4153441bdc.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.texashealth.org/Locations/texas-health-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=13340692452757302000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hospital-fort-worth",
      "poi_latitude": "32.7380013",
      "poi_longitude": "-97.3399244",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-250-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yKG8HBxToYR8GpVkBqpI7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0eb0a9fd21a501173314065b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "John Peter Smith Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 S Main St, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-0444-7334-8b71-281659b27366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-0444-7334-8b71-281659b27366",
        "storage_key": "property/5754272234864640/019f1514-0444-7334-8b71-281659b27366.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.jpshealthnet.org/locations/jpshospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646798849451524257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-peter-smith-hospital",
      "poi_latitude": "32.7277649",
      "poi_longitude": "-97.3268923",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-702-3431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8Ld8qBxToYRoYBgR4x0gq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_3a268e9209195c604d2cd390",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Cook Children's Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "801 7th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-34b3-73ee-9d1e-25b0f2a00f64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-34b3-73ee-9d1e-25b0f2a00f64",
        "storage_key": "property/5754272234864640/019f1511-34b3-73ee-9d1e-25b0f2a00f64.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cookchildrens.org/medical-center/fort-worth/?utm_source=google&utm_medium=OrganicSearch&utm_campaign=yext&y_source=1_MTEzNzc5ODgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985657874343977757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cook-childrens-medical-center",
      "poi_latitude": "32.737",
      "poi_longitude": "-97.340842",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 682-885-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS7naHpxToYRHeM-2KHldJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_2fe6a12f93d5867dff413fc0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Medical City Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "900 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ff9b-7379-8609-485f1d52252e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ff9b-7379-8609-485f1d52252e",
        "storage_key": "property/5754272234864640/019f1513-ff9b-7379-8609-485f1d52252e.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-fort-worth-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=524071590630840069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-fort-worth",
      "poi_latitude": "32.7358664",
      "poi_longitude": "-97.3452877",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-336-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2QNkntxToYRBddsxFXgRQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_372b2bdf2718bebd9a3f4e83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Legend Internal Medicine Urgent Care & Diagnostics PA",
      "poi_type": "Health and Wellness",
      "poi_address": "609 Hemphill St #101, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-006e-7658-a1cc-259f334dfacb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-006e-7658-a1cc-259f334dfacb",
        "storage_key": "property/5754272234864640/019f1514-006e-7658-a1cc-259f334dfacb.webp",
        "width": 990,
        "height": 270
      },
      "poi_business_url": "http://www.legendinternalmedicine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2159818378763835698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legend-internal-medicine-urgent-care--diagnostics-pa",
      "poi_latitude": "32.7378809",
      "poi_longitude": "-97.3316708",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-923-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzUcx4HJxToYRMhmUTV83-R0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_920c372b71402ce8596b174a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1115 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-e9af-716d-91c1-a534ad167294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-e9af-716d-91c1-a534ad167294",
        "storage_key": "property/5754272234864640/019f1513-e9af-716d-91c1-a534ad167294.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/fort-worth-tx-pharmacies/1115-8th-avenue-fort-worth-tx-76104/storeid=11323?WT.mc_id=LS_GOOGLE_RX_11323",
      "poi_directions_map_url": "https://maps.google.com/?cid=5788496377098122102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.7325488",
      "poi_longitude": "-97.3434808",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-806-1094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f8e-753a-9983-f8600231da6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f8e-753a-9983-f8600231da6d",
        "storage_key": "property/5754272234864640/019f1514-1f8e-753a-9983-f8600231da6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwLwGKlxToYRdrORRMneVFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_361daa8afdf5fddb46c1ca4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1050 W Rosedale St Suite 100, Fort Worth, TX 76104, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-013f-775b-81ea-9dd531492715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-013f-775b-81ea-9dd531492715",
        "storage_key": "property/5754272234864640/019f1514-013f-775b-81ea-9dd531492715.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1050+w+rosedale+st-fort+worth-tx-76104/id=16505",
      "poi_directions_map_url": "https://maps.google.com/?cid=5514784284732399233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy",
      "poi_latitude": "32.7333904",
      "poi_longitude": "-97.336126",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-316-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f8e-753a-9983-f8600231da6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f8e-753a-9983-f8600231da6d",
        "storage_key": "property/5754272234864640/019f1514-1f8e-753a-9983-f8600231da6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSAemHZxToYRgZ5hoBZziEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b55d1fe8a6a1c2fd4248fcfe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Southside Pilates Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "1289 Hemphill St #101, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-02a6-75f6-b035-132bc349d799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-02a6-75f6-b035-132bc349d799",
        "storage_key": "property/5754272234864640/019f1514-02a6-75f6-b035-132bc349d799.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.southsidepilatesfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15004385672337614010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-pilates-fort-worth",
      "poi_latitude": "32.7311511",
      "poi_longitude": "-97.3313276",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-703-0290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bhx1MJxToYRuuSkuEVJOtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_6a79ff31648c52d2d08bd071",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "UNION Cycle + Strength",
      "poi_type": "Health and Wellness",
      "poi_address": "201 Lipscomb St Ste 151, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-0630-77d5-9941-d38d077631dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-0630-77d5-9941-d38d077631dc",
        "storage_key": "property/5754272234864640/019f1514-0630-77d5-9941-d38d077631dc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://union-cycle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18334160867972604297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-cycle--strength",
      "poi_latitude": "32.7426076",
      "poi_longitude": "-97.3328941",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-585-1021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJneH1bsBxToYRieFfvisGcP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_17331a5d5cc4c819545886a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Amon Carter Jr. Downtown YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "512 Lamar St Ste 100, Fort Worth, TX 76102, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-04ab-712d-acdc-570d3763501a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-04ab-712d-acdc-570d3763501a",
        "storage_key": "property/5754272234864640/019f1514-04ab-712d-acdc-570d3763501a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://ymcafw.org/locations/downtown-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7485050176909079077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amon-carter-jr-downtown-ymca",
      "poi_latitude": "32.752379",
      "poi_longitude": "-97.3343561",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-332-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG3Q06UFxToYRJfKjeHo94Gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_0e3cf7849e00627573898731",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Trinity Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2401 University Dr, Fort Worth, TX 76107, USA",
      "poi_short_description": "Public 252-acre park along the Trinity River, home to a pond, a fishing pier, playgrounds & trails.",
      "poi_long_description": "Public 252-acre park along the Trinity River, home to a pond, a fishing pier, playgrounds & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-3900-726b-b718-103cfc5183db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-3900-726b-b718-103cfc5183db",
        "storage_key": "property/5754272234864640/019f1511-3900-726b-b718-103cfc5183db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/trinity-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4643669985814802510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-park",
      "poi_latitude": "32.7435092",
      "poi_longitude": "-97.3555857",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-392-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f41-732c-b756-f19ea5966b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f41-732c-b756-f19ea5966b47",
        "storage_key": "property/5754272234864640/019f1511-4f41-732c-b756-f19ea5966b47.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxkdkNBzToYRTnCitj-hcUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f10db13c4364aa66006fec07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth Botanic Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3220 Botanic Garden Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Lush 120-acre garden & event venue with famed Japanese landscape, nature classes & May herb fest.",
      "poi_long_description": "Lush 120-acre garden & event venue with famed Japanese landscape, nature classes & May herb fest.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-37eb-71dc-928e-7babe2e87b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-37eb-71dc-928e-7babe2e87b17",
        "storage_key": "property/5754272234864640/019f1511-37eb-71dc-928e-7babe2e87b17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fwbg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3356345469016191039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-botanic-garden",
      "poi_latitude": "32.7403425",
      "poi_longitude": "-97.3638144",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-463-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzGrNcVzToYRP7Az4GsilC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_0f317dd330bbdddb9cc99b92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Botanical Research Institute of Texas",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1700 University Dr, Fort Worth, TX 76107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-07d4-72ed-93ec-25a4f7c91024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-07d4-72ed-93ec-25a4f7c91024",
        "storage_key": "property/5754272234864640/019f1514-07d4-72ed-93ec-25a4f7c91024.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.brit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=477897922138584342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "botanical-research-institute-of-texas",
      "poi_latitude": "32.7422092",
      "poi_longitude": "-97.3626741",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-332-4441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn0jNHj9xToYRFrX3z6DVoQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_4ae2e84203b0a22db33144da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Panther Island Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "395 Purcey St, Fort Worth, TX 76102, USA",
      "poi_short_description": "This event venue offers a waterfront stage, 2 bandshells & a beach plus kayak & paddleboard rentals.",
      "poi_long_description": "This event venue offers a waterfront stage, 2 bandshells & a beach plus kayak & paddleboard rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-0829-7752-966e-d63fe5fe248b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-0829-7752-966e-d63fe5fe248b",
        "storage_key": "property/5754272234864640/019f1514-0829-7752-966e-d63fe5fe248b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://pantherislandpavilion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=506487674400295194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panther-island-pavilion",
      "poi_latitude": "32.760343",
      "poi_longitude": "-97.3393869",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-335-2491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVa3n71xxToYRGkm-O9tnBwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_4c8aa38ad0b8e74f24ed5427",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth Water Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1502 Commerce St, Fort Worth, TX 76102, USA",
      "poi_short_description": "Tranquil Philip Johnson-designed urban park featuring 4.3 acres of waterfalls, pools & fountains.",
      "poi_long_description": "Tranquil Philip Johnson-designed urban park featuring 4.3 acres of waterfalls, pools & fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f633-760e-a321-19278ca66394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f633-760e-a321-19278ca66394",
        "storage_key": "property/5754272234864640/019f1513-f633-760e-a321-19278ca66394.webp",
        "width": 1200,
        "height": 804
      },
      "poi_business_url": "http://www.fortworth.com/things-to-do/attractions/fort-worth-water-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13328630581232758923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-water-gardens",
      "poi_latitude": "32.747749",
      "poi_longitude": "-97.32663",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-392-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqj5xToYRi3DJQOXO-Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_28c24b3826e4801fa3b54c74",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Burk Burnett Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 W 7th St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-0e69-701b-9697-bc05d915f028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-0e69-701b-9697-bc05d915f028",
        "storage_key": "property/5754272234864640/019f1514-0e69-701b-9697-bc05d915f028.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortworthtexas.gov/departments/parks/parks-and-trails/burke-burnett-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4538408389412240318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burk-burnett-park",
      "poi_latitude": "32.750451",
      "poi_longitude": "-97.333705",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-870-1692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f41-732c-b756-f19ea5966b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f41-732c-b756-f19ea5966b47",
        "storage_key": "property/5754272234864640/019f1511-4f41-732c-b756-f19ea5966b47.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT01FaGpxToYRvruReGKq-z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2dbb5bdd8b6ff73a44a12aaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth Zoo",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1989 Colonial Pkwy, Fort Worth, TX 76110, USA",
      "poi_short_description": "Acclaimed attraction housing 7,000 animals in themed habitats, plus interactive activities & camps.",
      "poi_long_description": "Acclaimed attraction housing 7,000 animals in themed habitats, plus interactive activities & camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-2719-73bb-88aa-457d8f091459.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-2719-73bb-88aa-457d8f091459",
        "storage_key": "property/5754272234864640/019f1511-2719-73bb-88aa-457d8f091459.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.fortworthzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4707172094723069637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-zoo",
      "poi_latitude": "32.7231585",
      "poi_longitude": "-97.3564467",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-759-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO72Uyi1yToYRxZaZmhQ8U0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_3fca085f3ac6dc250395d68f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Kimbell Art Museum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3333 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_long_description": "Renowned Asian- & European-focused collection plus exhibits set in a Louis Kahn-designed building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-2b6e-70ea-bcf2-11872d90d4e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-2b6e-70ea-bcf2-11872d90d4e6",
        "storage_key": "property/5754272234864640/019f1511-2b6e-70ea-bcf2-11872d90d4e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kimbellart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239859824201680144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimbell-art-museum",
      "poi_latitude": "32.7485687",
      "poi_longitude": "-97.3649208",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-332-8451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_3ggMJzToYREMUp1SYmeWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_e3a79b34701521a56aef9670",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Amon Carter Museum of American Art",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3501 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_long_description": "Western artworks including those by Remington & Russell, plus Hudson River School paintings & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ffa1-75cf-b059-295dea9e63b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ffa1-75cf-b059-295dea9e63b9",
        "storage_key": "property/5754272234864640/019f1513-ffa1-75cf-b059-295dea9e63b9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cartermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2896534922228772865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amon-carter-museum-of-american-art",
      "poi_latitude": "32.747867",
      "poi_longitude": "-97.368447",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-738-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbcQcjcFzToYRAbD1TiqPMig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ad8fc1b9ef1aca4ff0a6c26f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Modern Art Museum of Fort Worth",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 Darnell St, Fort Worth, TX 76107, USA",
      "poi_short_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_long_description": "Acclaimed contemporary complex with a reflecting pool housing more than 3,000 post-WWII artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ff49-7591-8136-94090a4018b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ff49-7591-8136-94090a4018b2",
        "storage_key": "property/5754272234864640/019f1513-ff49-7591-8136-94090a4018b2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.themodern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12620084409265249041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "modern-art-museum-of-fort-worth",
      "poi_latitude": "32.7491803",
      "poi_longitude": "-97.3633072",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-738-9215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f42-72ed-8a96-9634043fa22e",
        "storage_key": "property/5754272234864640/019f1511-4f42-72ed-8a96-9634043fa22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5w_isJzToYREVuz-eeLI68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_24ab37f2ccf5b026bec5eda9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4025-7366-b260-9b25424a96b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-4025-7366-b260-9b25424a96b8",
        "storage_key": "property/5754272234864640/019f1511-4025-7366-b260-9b25424a96b8.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a6992f9e180e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a6992f9e180e",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a6992f9e180e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_69524b995f52b8949e8c0f4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth T&p",
      "poi_type": "Transportation & Transit",
      "poi_address": "221 W Lancaster Ave, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-3f54-731b-bf6c-0515be6c9e43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-3f54-731b-bf6c-0515be6c9e43",
        "storage_key": "property/5754272234864640/019f1511-3f54-731b-bf6c-0515be6c9e43.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/fort-worth-tp-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2586634399591785905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-tp",
      "poi_latitude": "32.7453226",
      "poi_longitude": "-97.3279067",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a6992f9e180e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a6992f9e180e",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a6992f9e180e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TtRaxNxToYRsWV5J0iS5SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_b76e21e6a7dcb2757010b123",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Vickery Transfer Center (Curb Side)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13904666374112973018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vickery-transfer-center-curb-side",
      "poi_latitude": "32.743775",
      "poi_longitude": "-97.327273",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4YmABNxToYR2pBSrWVM98A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_0c392b77aa90434898dff6c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth BCycle: Fort Worth Central Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St Ste B, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-11f2-73aa-978f-b025f919208e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-11f2-73aa-978f-b025f919208e",
        "storage_key": "property/5754272234864640/019f1514-11f2-73aa-978f-b025f919208e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://fortworth.bcycle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16316014703739805302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-bcycle-fort-worth-central-station",
      "poi_latitude": "32.7526707",
      "poi_longitude": "-97.3266876",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f02-775f-b11c-20fb467c6b9f",
        "storage_key": "property/5754272234864640/019f1511-4f02-775f-b11c-20fb467c6b9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9lUJz5xToYRdh52Vu0gbuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bike_sharing_station"
    },
    {
      "id": "ec_6d78c2da6dd7c93538896e3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-105b-72f3-8db8-7792e747f18a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-105b-72f3-8db8-7792e747f18a",
        "storage_key": "property/5754272234864640/019f1514-105b-72f3-8db8-7792e747f18a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "23.3 mi",
      "poi_walking_minutes": "8 hours 39 mins",
      "poi_biking_minutes": "2 hours 29 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4f-719f-b37b-7985043abb49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4f-719f-b37b-7985043abb49",
        "storage_key": "property/5754272234864640/019f1511-4f4f-719f-b37b-7985043abb49.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_3aabf9f6fd39660175f90d83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Baylor Scott & White All Saints Medical Center - Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1400 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-0fa9-77bb-8c36-075d2791fc28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-0fa9-77bb-8c36-075d2791fc28",
        "storage_key": "property/5754272234864640/019f1514-0fa9-77bb-8c36-075d2791fc28.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/fort-worth?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-8119502",
      "poi_directions_map_url": "https://maps.google.com/?cid=14939051515624993574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-all-saints-medical-center---fort-worth",
      "poi_latitude": "32.7295641",
      "poi_longitude": "-97.3452152",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-926-2544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8FWXkJtToYRJrMW9jMsUs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_c334ab11a98016fa4c888528",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hospital Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 Pennsylvania Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-3576-74d6-80cf-bf4153441bdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-3576-74d6-80cf-bf4153441bdc",
        "storage_key": "property/5754272234864640/019f1511-3576-74d6-80cf-bf4153441bdc.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.texashealth.org/Locations/texas-health-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=13340692452757302000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hospital-fort-worth",
      "poi_latitude": "32.7380013",
      "poi_longitude": "-97.3399244",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-250-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yKG8HBxToYR8GpVkBqpI7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_f94aef54dc6d884d9b714916",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "John Peter Smith Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 S Main St, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-0444-7334-8b71-281659b27366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-0444-7334-8b71-281659b27366",
        "storage_key": "property/5754272234864640/019f1514-0444-7334-8b71-281659b27366.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.jpshealthnet.org/locations/jpshospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12646798849451524257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-peter-smith-hospital",
      "poi_latitude": "32.7277649",
      "poi_longitude": "-97.3268923",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-702-3431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8Ld8qBxToYRoYBgR4x0gq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_86a207412a67572f7de7f429",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Cook Children's Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 7th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-34b3-73ee-9d1e-25b0f2a00f64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-34b3-73ee-9d1e-25b0f2a00f64",
        "storage_key": "property/5754272234864640/019f1511-34b3-73ee-9d1e-25b0f2a00f64.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cookchildrens.org/medical-center/fort-worth/?utm_source=google&utm_medium=OrganicSearch&utm_campaign=yext&y_source=1_MTEzNzc5ODgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985657874343977757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cook-childrens-medical-center",
      "poi_latitude": "32.737",
      "poi_longitude": "-97.340842",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 682-885-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS7naHpxToYRHeM-2KHldJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_f1dfb353592c7866acd72440",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Medical City Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-ff9b-7379-8609-485f1d52252e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-ff9b-7379-8609-485f1d52252e",
        "storage_key": "property/5754272234864640/019f1513-ff9b-7379-8609-485f1d52252e.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-fort-worth-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=524071590630840069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-fort-worth",
      "poi_latitude": "32.7358664",
      "poi_longitude": "-97.3452877",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-336-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4ef7-7488-8acf-a1556752982d",
        "storage_key": "property/5754272234864640/019f1511-4ef7-7488-8acf-a1556752982d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2QNkntxToYRBddsxFXgRQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0cf7d6c7621f3d125f980d23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "UNT Health Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3500 Camp Bowie Blvd, Fort Worth, TX 76107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1513-f4c2-74f9-9095-55bfb43baced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-f4c2-74f9-9095-55bfb43baced",
        "storage_key": "property/5754272234864640/019f1513-f4c2-74f9-9095-55bfb43baced.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.unthealth.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001576964368720476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unt-health-fort-worth",
      "poi_latitude": "32.7496982",
      "poi_longitude": "-97.3694771",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-735-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQcyAaOpzToYRXGKpviu88es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_0590f623a8d77ef6a0f5ff2c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Texas Christian University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 S University Dr, Fort Worth, TX 76109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-1e22-7196-a125-5551a443b280.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-1e22-7196-a125-5551a443b280",
        "storage_key": "property/5754272234864640/019f1511-1e22-7196-a125-5551a443b280.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=375771055333629936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-christian-university",
      "poi_latitude": "32.7078531",
      "poi_longitude": "-97.3628041",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-257-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_b0MPT1yToYR8N8IrsgBNwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1427fc212c90108691dd9eed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Texas Wesleyan University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Wesleyan St, Fort Worth, TX 76105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-214d-7355-864b-d389f42100ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1511-214d-7355-864b-d389f42100ac",
        "storage_key": "property/5754272234864640/019f1511-214d-7355-864b-d389f42100ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://txwes.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13046821111412638950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-wesleyan-university",
      "poi_latitude": "32.7323764",
      "poi_longitude": "-97.280207",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-531-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk2jX2olwToYR5kTRAa2eD7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_dae88006d3b6c0b3ade95ecc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "Fort Worth City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Texas St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-125d-76eb-8177-6962b475f18a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-125d-76eb-8177-6962b475f18a",
        "storage_key": "property/5754272234864640/019f1514-125d-76eb-8177-6962b475f18a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fortworthtexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13845863648493937333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-city-hall",
      "poi_latitude": "32.7488978",
      "poi_longitude": "-97.3308231",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-392-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-1f68-705a-9693-f0eed9fb4d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-1f68-705a-9693-f0eed9fb4d66",
        "storage_key": "property/5754272234864640/019f1514-1f68-705a-9693-f0eed9fb4d66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQVNyWpxToYRtaL5OKFjJsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_d6db5a2c39eecf9b22019119",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "poi_name": "FWISD District Service Center (DSC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7060 Camp Bowie Blvd, Fort Worth, TX 76116, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1514-126b-713f-93ac-813a25547379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-126b-713f-93ac-813a25547379",
        "storage_key": "property/5754272234864640/019f1514-126b-713f-93ac-813a25547379.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fwisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15134471432473832560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fwisd-district-service-center-dsc",
      "poi_latitude": "32.7207508",
      "poi_longitude": "-97.4377975",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-814-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1511-4f4e-779d-9472-3bb7831c3127",
        "storage_key": "property/5754272234864640/019f1511-4f4e-779d-9472-3bb7831c3127.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2bsuPeVzToYRcGzm-5RxCNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b28a5825-ae22-409b-a345-df49f700b0a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_090539eb-ae28-4b3c-acfe-8d87d28a597f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aa49bd6a-89e8-480e-8cfc-5cccc9674517",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6ef9a01f-193c-4e20-8965-a384ce711300",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_17950660-d167-4484-a781-f73ce029e46c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_99509ed9-066b-4786-9ee0-35113a69a6b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_07399eb089ccc27972efff7e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "rating": "5",
      "name": "Leah",
      "text": "I just moved into Broadway Chapter Apartments this past weekend, and I have to give credit where it’s due. I’ve lived in several apartment complexes before, but this one is by far the best. From the leasing office to maintenance, and even the residents, everyone is so welcoming and friendly. The leasing agents made the whole process smooth and stress-free.\n\nA special thank you to Izabella, Katie, and Megan for going above and beyond to make my move in experience amazing!🥰 I toured the community virtually, and it’s just as beautiful in person. The appliances are modern, and everything is clean, updated, and well-maintained. I’m so glad I chose to make Broadway Chapter my new home!",
      "date": "2025-11-10",
      "title": "false"
    },
    {
      "id": "ec_b04ce83af88c1d20564d135f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "rating": "5",
      "name": "jacqueline chandler",
      "text": "⭐⭐⭐⭐⭐\n\nI had a bit of a hectic move-in process and honestly was a little all over the place due to life circumstances and needing to move quickly. Throughout everything, Isabella and the management team were incredibly patient, kind, and understanding.\n\nThey worked with me through multiple unit changes, answered my questions, and never once made me feel like I was being a burden or that I wasn’t welcome. Isabella, in particular, was so helpful and professional, and the manager was just as accommodating.\n\nI truly appreciate the grace and support they showed me during a stressful time, and I’m grateful to have found a place I can now call home. Thank you to the entire team for making this transition easier for me.",
      "date": "2026-01-17",
      "title": "false"
    },
    {
      "id": "ec_bc1c4c37fb7dc729af9aa4ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "rating": "5",
      "name": "Gabrielle Roberts",
      "text": "First off, Janine is HEAVEN SENT! We needed to get an apartment within weeks and we found Broadway Chapter. Janine is very knowledgeable of the property and has great hospitality. The facilities are beautiful and I love that we are the first to be moving into our unit. Janine helped us so much and made sure that all of our paperwork was done and ready to go. I can’t wait to spend my time here with my fiancé. Here are some photos of the model room she showed us so we could get a feel for how big it would be.",
      "date": "2022-03-04",
      "title": "false"
    },
    {
      "id": "ec_3d85e8624dac3bdd58e640f1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "rating": "5",
      "name": "Sanjna Tripathy",
      "text": "Megan is absolutely amazing and she really cares about the residents who live here. As with any apt complex there will be things that come up, but the difference is here they will take a personal interest in your well being and care about you. And the social events they have are such a fun bonus! I have made wonderful friends I don’t think I would’ve at any other place because they focus on building a community. Would recommend living here for anyone new to the area. It is also walkable to many bars, coffee shops, gyms, and restaurants.",
      "date": "2025-09-30",
      "title": "false"
    },
    {
      "id": "ec_fc1015e54a2a3db192032c69",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "rating": "5",
      "name": "chris gideon",
      "text": "Broadway chapter absolutely SETS THE STANDARD for any apartment complex in DFW! The amenities here are top notch the pool is always sparkling clean and perfect for unwinding, the dog park is a lifesaver for my pup, and the on-site convenience store makes grabbing last-minute essentials effortless. The fitness center is well-equipped and clean so I never have to worry about what time I can go to the gym considering it’s 24 hours. They also have awesome community events regularly and a fun “pet of the month” contest every month to show off our furry family members!\n\nBut what truly makes this place special is the amazing staff, especially Megan!!! She goes above and beyond to make sure residents feel welcome and taken care of. Her friendliness, professionalism, and dedication make all the difference. Whether it's answering questions, resolving issues, or just greeting you with a smile, Megan and the rest of the team truly make  living here an incredible experience.\n\nIf you're looking for a place with great amenities, a welcoming community, and a staff that genuinely cares this is It!",
      "date": "2025-03-17",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_41ed6b38c3e12b8196ecf2a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019d02f4-23fc-74b1-b353-df3e135be02a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances.",
        "public_id": "019d02f4-23fc-74b1-b353-df3e135be02a",
        "storage_key": "property/5754272234864640/019d02f4-23fc-74b1-b353-df3e135be02a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 711SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=DaMyMSwDSof&play=1"
    },
    {
      "id": "ec_efebfe6f1ca76c2d747f61c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f14c4-a14d-75fa-90c9-88400f04c3bc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-a14d-75fa-90c9-88400f04c3bc",
        "storage_key": "property/5754272234864640/019f14c4-a14d-75fa-90c9-88400f04c3bc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1085SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=v6cJQSBtmWN&play=1"
    }
  ],
  "faqs": [
    {
      "id": "custom_45fc4d90-698f-4d0a-b521-5b46f052b4dc",
      "question": "Is Broadway Chapter pet-friendly?",
      "answer": "Yes. Broadway Chapter welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (817) 415-1000 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_6bdc9f73-f793-44e8-b1ba-1c8e2b3a4003",
      "question": "How can I schedule a tour at Broadway Chapter?",
      "answer": "You can schedule a tour of Broadway Chapter online through our Schedule a Tour page, or call the leasing office at (817) 415-1000. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_a04f4a61-fba3-47ee-ac52-128e633aa4dc",
      "question": "What are the leasing office hours at Broadway Chapter?",
      "answer": "The Broadway Chapter leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (817) 415-1000 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_03877754-1ed8-46f4-94a6-84f90cc9df90",
      "question": "What floor plans are available at Broadway Chapter?",
      "answer": "Broadway Chapter offers 1- and 2-bedroom apartment homes ranging from approximately 547 to 1,195 square feet, across 22 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_2937fdd2-f57f-4f2d-be55-20f77f2cfcfc",
      "question": "What amenities does Broadway Chapter have?",
      "answer": "Broadway Chapter offers a range of community and in-home amenities. Community amenities include: Infinity Edge Pool, In‑Pool Loungers & Sundeck, Fitness Center w/ Peleton & Yoga Area, Resident Lounge w/ Coffee Bar, Community Market, Zoom Rooms, Resident Library, Poolside Grilling & Dining Area, Community Fireside Lounge, Bike Racks, Bark Park For Your Furry Friends, Convenient 24/7 Online Resident Services, and American Landmark 360 Resident Program. In-home features include: wood‑style plank flooring, stainless steel appliances, walk‑in closets, full‑size washer & dryer, keyless fob entry, 20' ceilings in lofts, oversized windows, private balconies, and expansive downtown views*. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_96f4ce4d-d714-4a6e-a327-895b8408e0d4",
      "question": "Where is Broadway Chapter located?",
      "answer": "Broadway Chapter is located at 401 Hemphill St, Fort Worth TX 76104. Nearby you'll find dining at Proper, shopping at QuikTrip, and green space at Trinity Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_8f6f38f4-d190-44f9-b880-6398e67f15ba",
      "question": "How do I apply to live at Broadway Chapter?",
      "answer": "You can apply to live at Broadway Chapter online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (817) 415-1000 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_1abf99d2-2418-4b85-974d-23580c578739",
      "question": "What do I need to apply at Broadway Chapter?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Broadway Chapter leasing team at (817) 415-1000 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_6655e230-6eff-4b57-ad25-697366b11873",
      "question": "What is the Landmark 360 program at Broadway Chapter?",
      "answer": "Broadway Chapter participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (817) 415-1000 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_d6964b91-3d34-4b11-af71-4afcb911e0b3",
      "question": "Does Broadway Chapter have a pool?",
      "answer": "Yes. Broadway Chapter has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_fc803727-50cd-4e2e-9581-d73a175ec82c",
      "question": "Does Broadway Chapter have a fitness center?",
      "answer": "Yes. Broadway Chapter has a 24-hour fitness center available to residents at any time. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_c094d2b8-ed85-49c8-b9e7-9e2b64013da6",
      "question": "Does Broadway Chapter offer virtual tours?",
      "answer": "Yes. Broadway Chapter offers virtual tours of 1BR, 1BA - 711SF and 2BR, 2BA - 1085SF. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_f97ecceb-cc21-41c4-aef9-6fb64241e29d",
      "question": "What do residents say about living at Broadway Chapter?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Broadway Chapter. One resident wrote: *\"I just moved into Broadway Chapter Apartments this past weekend, and I have to give credit where it’s due. I’ve lived in several apartment complexes before, but this one is by far the best.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_206d3582-73d9-4b6c-845b-862e1522468d",
      "question": "When was Broadway Chapter built?",
      "answer": "Broadway Chapter was built in 2021. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_7d23321f-d450-448b-8426-ce2c27bb62bf",
      "question": "What is the pet fee at Broadway Chapter?",
      "answer": "Pets at Broadway Chapter: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (817) 415-1000 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_4c3b4f6a-3a1c-4fc8-92d8-cb0b52b499ba",
      "question": "What features are included in the apartments at Broadway Chapter?",
      "answer": "Apartment homes at Broadway Chapter include wood‑style plank flooring, stainless steel appliances, walk‑in closets, full‑size washer & dryer, keyless fob entry, 20' ceilings in lofts, oversized windows, private balconies, and expansive downtown views*. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_87af7b33-afec-4768-8413-b52cd246b03c",
      "question": "What restaurants and shops are near Broadway Chapter?",
      "answer": "Nearby restaurants and shops include Proper, Fixture - Kitchen and Social Lounge, Spiral Diner & Bakery, and Pie Tap Pizza + Rotisserie + Bar. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-32f0-775e-ac61-c16f33863a8d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "broadway-chapter",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640"
    },
    {
      "lead_collector_id": "0198aa45-3353-770a-8315-d81c088ec766",
      "lead_source": "FACEBOOK_ADS",
      "name": "broadway-chapter",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640"
    },
    {
      "lead_collector_id": "0198aa45-33b4-715c-9d95-b5155cfa457a",
      "lead_source": "LANDING_PAGE",
      "name": "broadway-chapter",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "studio-apartments-for-rent-in-ft-worth-tx",
      "search_query": "Studio Apartments For Rent In Ft Worth TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments For Rent In Ft Worth TX",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at Broadway Chapter. Our studio apartments feature modern amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find premium studio apartments for rent in Ft Worth TX. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Each studio apartment features a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances, including a dishwasher, disposal, ice maker, oven, range, and refrigerator. Enjoy additional features like vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Studio Apartments For Rent In Ft Worth TX",
      "seo_description": "Find studio apartments for rent in Ft Worth TX at Broadway Chapter. Enjoy modern amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-in-ft-worth-tx",
      "search_query": "One Bedroom Apartments For Rent In Ft Worth TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Ft Worth TX",
      "h2_subtitle": "Experience modern living at Broadway Chapter with our spacious one-bedroom apartments. Enjoy top-notch amenities and a prime location in Ft Worth.",
      "page_copy": "Welcome to Broadway Chapter, your destination for one bedroom apartments for rent in Ft Worth TX. Managed by American Landmark, our community is situated in Tarrant County within the 76104 ZIP Code and is part of the Fort Worth Independent attendance zone. Each one-bedroom apartment features a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances, including a dishwasher, disposal, ice maker, oven, range, and refrigerator. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Discover the perfect blend of comfort and convenience at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | One Bedroom Apartments For Rent In Ft Worth TX",
      "seo_description": "Discover one bedroom apartments for rent in Ft Worth TX at Broadway Chapter. Enjoy modern amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-in-ft-worth-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Ft Worth TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Ft Worth TX",
      "h2_subtitle": "Find your ideal home at Broadway Chapter with our spacious two-bedroom apartments. Enjoy modern amenities and a convenient location in Ft Worth.",
      "page_copy": "Welcome to Broadway Chapter, where you can find two bedrooms apartments for rent in Ft Worth TX. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Each two-bedroom apartment features a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances, including a dishwasher, disposal, ice maker, oven, range, and refrigerator. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Two Bedrooms Apartments For Rent In Ft Worth TX",
      "seo_description": "Explore two bedrooms apartments for rent in Ft Worth TX at Broadway Chapter. Enjoy modern amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Discover luxury living at Broadway Chapter with our stunning apartments. Enjoy top-tier amenities, including a refreshing pool, in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with pool. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a sparkling pool, fitness center, sundeck, courtyard, grill, dog park, lounge, conference rooms, and bicycle storage. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Experience premium living at Broadway Chapter with our modern apartments. Enjoy a state-of-the-art fitness center and other top amenities in Ft Worth.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with fitness center. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a state-of-the-art fitness center, along with other amenities such as a pool, sundeck, courtyard, grill, dog park, lounge, conference rooms, and bicycle storage. Discover the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-sundeck",
      "search_query": "Apartments For Rent Near Me with Sundeck",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Sundeck",
      "h2_subtitle": "Enjoy luxury living at Broadway Chapter with our modern apartments. Relax on our spacious sundeck and take advantage of other top amenities in Ft Worth.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with sundeck. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a spacious sundeck, along with other amenities such as a pool, fitness center, courtyard, grill, dog park, lounge, conference rooms, and bicycle storage. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Sundeck",
      "seo_description": "Find apartments for rent near me with sundeck at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-courtyard",
      "search_query": "Apartments For Rent Near Me with Courtyard",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Courtyard",
      "h2_subtitle": "Discover serene living at Broadway Chapter with our modern apartments. Enjoy a beautiful courtyard and other top amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with courtyard. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a beautiful courtyard, along with other amenities such as a pool, fitness center, sundeck, grill, dog park, lounge, conference rooms, and bicycle storage. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Courtyard",
      "seo_description": "Find apartments for rent near me with courtyard at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-grill",
      "search_query": "Apartments For Rent Near Me with Grill",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Grill",
      "h2_subtitle": "Experience upscale living at Broadway Chapter with our modern apartments. Enjoy a community grill and other top amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with grill. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a convenient grill area, along with other amenities such as a pool, fitness center, sundeck, courtyard, dog park, lounge, conference rooms, and bicycle storage. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Grill",
      "seo_description": "Find apartments for rent near me with grill at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen",
      "h2_subtitle": "Discover modern living at Broadway Chapter with our well-equipped apartments. Enjoy a fully functional kitchen and other top amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with kitchen. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Each apartment features a fully equipped kitchen with stainless steel appliances, including a refrigerator, oven, range, dishwasher, disposal, and ice maker. Additional amenities include a washer/dryer, air conditioning, walk-in closets, vaulted ceilings, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Find apartments for rent near me with kitchen at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Walk-In Closets",
      "h2_subtitle": "Experience spacious living at Broadway Chapter with our modern apartments. Enjoy walk-in closets and other top amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with walk-in closets. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Each apartment features spacious walk-in closets, along with a fully equipped kitchen with stainless steel appliances, including a refrigerator, oven, range, dishwasher, disposal, and ice maker. Additional amenities include a washer/dryer, air conditioning, vaulted ceilings, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Find apartments for rent near me with walk-in closets at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-vaulted-ceiling",
      "search_query": "Apartments For Rent Near Me with Vaulted Ceiling",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Vaulted Ceiling",
      "h2_subtitle": "Discover elevated living at Broadway Chapter with our modern apartments. Enjoy vaulted ceilings and other top amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with vaulted ceiling. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Each apartment features impressive vaulted ceilings, along with a fully equipped kitchen with stainless steel appliances, including a refrigerator, oven, range, dishwasher, disposal, and ice maker. Additional amenities include a washer/dryer, air conditioning, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Vaulted Ceiling",
      "seo_description": "Find apartments for rent near me with vaulted ceiling at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-balcony",
      "search_query": "Apartments For Rent Near Me with Balcony",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Balcony",
      "h2_subtitle": "Experience outdoor living at Broadway Chapter with our modern apartments. Enjoy private balconies and other top amenities in a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent near me with balcony. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Each apartment features a private balcony, along with a fully equipped kitchen with stainless steel appliances, including a refrigerator, oven, range, dishwasher, disposal, and ice maker. Additional amenities include a washer/dryer, air conditioning, walk-in closets, vaulted ceilings, and private outdoor spaces such as a patio or yard. Experience the best of Ft Worth living at Broadway Chapter.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent Near Me with Balcony",
      "seo_description": "Find apartments for rent near me with balcony at Broadway Chapter. Enjoy luxury amenities and a prime location in Tarrant County. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-ft-worth-tx-near-cook-childrens",
      "search_query": "Apartments For Rent In Ft Worth TX Near Cook Children's Medical Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near Cook Children's Medical Center",
      "h2_subtitle": "Discover convenient living at Broadway Chapter, just minutes from Cook Children's Medical Center. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near Cook Children's Medical Center. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near Cook Children's Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near Cook Children's Medical Center",
      "seo_description": "Find apartments for rent in Ft Worth TX near Cook Children's Medical Center at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-ft-worth-tx-near-john-peter-smith-hospital",
      "search_query": "Apartments For Rent In Ft Worth TX Near John Peter Smith Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near John Peter Smith Hospital",
      "h2_subtitle": "Experience convenient living at Broadway Chapter, just minutes from John Peter Smith Hospital. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near John Peter Smith Hospital. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near John Peter Smith Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near John Peter Smith Hospital",
      "seo_description": "Find apartments for rent in Ft Worth TX near John Peter Smith Hospital at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-ft-worth-tx-near-unt-health-center",
      "search_query": "Apartments For Rent In Ft Worth TX Near UNT Health Science Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near UNT Health Science Center",
      "h2_subtitle": "Discover convenient living at Broadway Chapter, just minutes from UNT Health Science Center. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near UNT Health Science Center. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near UNT Health Science Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near UNT Health Science Center",
      "seo_description": "Find apartments for rent in Ft Worth TX near UNT Health Science Center at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-ft-worth-tx-near-dr-todd-pearson",
      "search_query": "Apartments For Rent In Ft Worth TX Near Dr. Todd Pearson",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near Dr. Todd Pearson",
      "h2_subtitle": "Discover convenient living at Broadway Chapter, just minutes from Dr. Todd Pearson's office. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near Dr. Todd Pearson. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near Dr. Todd Pearson's office.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near Dr. Todd Pearson",
      "seo_description": "Find apartments for rent in Ft Worth TX near Dr. Todd Pearson at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-ft-worth-tx-near-tcu",
      "search_query": "Apartments For Rent In Ft Worth TX Near Texas Christian University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near Texas Christian University",
      "h2_subtitle": "Discover convenient living at Broadway Chapter, just minutes from Texas Christian University. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near Texas Christian University. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near Texas Christian University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near Texas Christian University",
      "seo_description": "Find apartments for rent in Ft Worth TX near Texas Christian University at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-ft-worth-tx-near-oakridge-school",
      "search_query": "Apartments For Rent In Ft Worth TX Near The Oakridge School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near The Oakridge School",
      "h2_subtitle": "Discover convenient living at Broadway Chapter, just minutes from The Oakridge School. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near The Oakridge School. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near The Oakridge School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near The Oakridge School",
      "seo_description": "Find apartments for rent in Ft Worth TX near The Oakridge School at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5754272234864640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-harmony-science-academy-fw",
      "search_query": "Apartments For Rent In Ft Worth TX Near Harmony Science Academy - Fort Worth",
      "category": "POI",
      "h1_title": "Apartments For Rent In Ft Worth TX Near Harmony Science Academy - Fort Worth",
      "h2_subtitle": "Discover convenient living at Broadway Chapter, just minutes from Harmony Science Academy - Fort Worth. Enjoy modern amenities and a prime Ft Worth location.",
      "page_copy": "Welcome to Broadway Chapter, where you can find apartments for rent in Ft Worth TX near Harmony Science Academy - Fort Worth. Managed by American Landmark, our community is located in Tarrant County within the 76104 ZIP Code and is served by the Fort Worth Independent attendance zone. Choose from our available floor plans, including studio and two-bedroom apartments, each designed for your comfort and convenience. Our community features a range of amenities, including a lounge, conference rooms, fitness center, pool, bicycle storage, sundeck, courtyard, grill, and dog park. Each apartment is equipped with a washer/dryer, air conditioning, and a fully equipped kitchen with stainless steel appliances. Additional features include vaulted ceilings, walk-in closets, and private outdoor spaces such as a balcony, patio, or yard. Experience the best of Ft Worth living at Broadway Chapter, conveniently located near Harmony Science Academy - Fort Worth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a courtyard and city skyline in the background.",
        "public_id": "019f6c0c-ba92-75fe-84f2-c6647e0cb5c0",
        "storage_key": "property/5754272234864640/019f6c0c-ba92-75fe-84f2-c6647e0cb5c0.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7",
        "storage_key": "property/5754272234864640/019f6c0c-c3d7-738c-8d3f-dbb5eb4975d7.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Broadway Chapter | Apartments For Rent In Ft Worth TX Near Harmony Science Academy - Fort Worth",
      "seo_description": "Find apartments for rent in Ft Worth TX near Harmony Science Academy - Fort Worth at Broadway Chapter. Enjoy modern amenities and a prime location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2292"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505044104"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4978599"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K5BJ2LV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://broadwaych.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443974196"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/r5v52omjvny"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/6214ccc7-987d-4c1b-8b1e-04e4cc22e963"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-241-5995"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlraTh2Wk03MGl0T2M2VHI0dk9McWc9PSIsInZhbHVlIjoiQTVmMXF5V0ZaZDVQWUlWRXFVcUhBZz09IiwibWFjIjoiM2M2NzAzZDAyMDI2NWU3NTcyYmY2M2RhZmVlOWRiMmQ5ZDQ0MGQ5OWYwNTJlYmZmNmY1ZmI5NjAyZDlmNThjZiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2292",
  "custom_repli_id": "2505044104",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4978599",
  "custom_google_gtm_id": "GTM-K5BJ2LV",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://broadwaych.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443974196",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/r5v52omjvny",
  "custom_self_guided_tour_url": "https://selftournow.com/property/6214ccc7-987d-4c1b-8b1e-04e4cc22e963",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-241-5995",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlraTh2Wk03MGl0T2M2VHI0dk9McWc9PSIsInZhbHVlIjoiQTVmMXF5V0ZaZDVQWUlWRXFVcUhBZz09IiwibWFjIjoiM2M2NzAzZDAyMDI2NWU3NTcyYmY2M2RhZmVlOWRiMmQ5ZDQ0MGQ5OWYwNTJlYmZmNmY1ZmI5NjAyZDlmNThjZiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "b1cd17fa-2e1a-410b-8601-9f95d3a3f5e3",
  "custom_audioeye_site_hash": "10e8b33a8d7f41491e2c30c1efcc720e"
};

export const generatedAt = '2026-11-03T20:38:34.204Z';
